(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/building-floating-view/building-floating-view.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/building-floating-view/building-floating-view.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<canvas id=\"scene\" #scene touch-action=\"none\"></canvas>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/building-view/building-view.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/building-view/building-view.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<canvas id=\"scene\" #scene touch-action=\"none\"></canvas>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/design-building/design-building.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/design-building/design-building.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"w-100\" *ngIf=\"formSettings\">\n  <div class=\"d-flex flex-row align-items-center\">\n    <div class=\"col-card\">\n\n      <div class=\"card left-panel-card\">\n        <div class=\"card-body\">\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Felépítmény tömege</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"weight\" [(ngModel)]=\"building.weight\" required min=\"1\" step=\"0.1\" (change)=\"sanitizeForm()\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  t\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <hr />\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Felépítmény magassága</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"height\" [(ngModel)]=\"building.height\" required [min]=\"formSettings.height.min\" [max]=\"formSettings.height.max\" (change)=\"sanitizeForm()\" step=\"0.5\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Felépítmény hossza</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"length\" [(ngModel)]=\"building.length\" required [min]=\"formSettings.length.min\" [max]=\"formSettings.length.max\" (change)=\"sanitizeForm()\" step=\"0.5\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Felépítmény szélessége</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"width\" [(ngModel)]=\"building.width\" required [min]=\"formSettings.width.min\" [max]=\"formSettings.width.max\" (change)=\"sanitizeForm()\" step=\"0.5\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <hr />\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Felépítmény terület</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" disabled readonly [value]=\"building.width * building.length\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m<sup>2</sup>\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <hr />\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Szabad perem szélessége</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"extraWidth\" [(ngModel)]=\"building.extraWidth\" required min=\"0\" step=\"0.5\" (change)=\"sanitizeForm()\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Tető típusa</label>\n            <div>\n              <select class=\"form-control\" [(ngModel)]=\"building.roof\" name=\"type\" (change)=\"updateModelType()\">\n                <option [ngValue]=\"type\" *ngFor=\"let type of roofTypes\">{{type}}</option>\n              </select>\n            </div>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">\n              <input type=\"checkbox\" class=\"checkbox\" [(ngModel)]=\"building.solar\" />\n              Napelem\n            </label>\n          </div>\n\n        </div>\n      </div>\n\n    </div>\n    <div class=\"flex-grow-1 container-3d right-panel-view shadow-lg\">\n\n      <building-view *ngIf=\"show3d\" [building]=\"building\" (onChange)=\"sizeChanged($event.building)\"></building-view>\n\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/design-floating/design-floating.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/design-floating/design-floating.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"w-100\" *ngIf=\"formSettings\">\n  <div class=\"d-flex flex-row align-items-center\">\n    <div class=\"col-card\">\n\n      <div class=\"card left-panel-card\">\n        <div class=\"card-body compact-form\">\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Úszómű elem víz feletti része</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"aboveWater\" [(ngModel)]=\"floating.aboveWater\" required [min]=\"formSettings.aboveWater.min\" [max]=\"formSettings.aboveWater.max\" step=\"0.1\" (change)=\"sanitizeForm()\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Úszómű elem magassága</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"height\" [(ngModel)]=\"floating.height\" required [min]=\"formSettings.height.min\" [max]=\"formSettings.height.max\" (change)=\"sanitizeForm()\" step=\"0.1\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Úszómű elem hossza</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"length\" [(ngModel)]=\"floating.length\" required [min]=\"formSettings.length.min\" [max]=\"formSettings.length.max\" (change)=\"sanitizeForm()\" step=\"0.5\" (focus)=\"checkpoint()\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <!--\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Szélső úszómű elem hossza</label>\n            <span class=\"input-group\">\n              <span class=\"input-group-prepend\">\n                <span class=\"input-group-text\">\n                  <input type=\"checkbox\" [(ngModel)]=\"floating.useLength2\" name=\"useLength2\">\n                </span>\n              </span>\n              <input *ngIf=\"!floating.useLength2\" type=\"number\" class=\"form-control form-control-number\" name=\"length2\" [(ngModel)]=\"floating.length\" readonly disabled />\n              <input *ngIf=\"floating.useLength2\" type=\"number\" class=\"form-control form-control-number\" name=\"length2\" [(ngModel)]=\"floating.length2\" required min=\"1\" max=\"20\" step=\"0.5\" />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n          -->\n\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Úszómű elem szélessége</label>\n            <span class=\"input-group\">\n              <input type=\"number\" class=\"form-control form-control-number\" name=\"width\" [(ngModel)]=\"floating.width\" readonly disabled />\n              <span class=\"input-group-append\">\n                <span class=\"input-group-text\">\n                  m\n                </span>\n              </span>\n            </span>\n          </div>\n\n          <hr />\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Betonfal vastagságok</label>\n            <div>\n              <select class=\"form-control\" [(ngModel)]=\"floating.wallThickness\" name=\"type\">\n                <option [ngValue]=\"type\" *ngFor=\"let type of wallThicknessTypes\">{{type}}</option>\n              </select>\n            </div>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Polisztirol típus</label>\n            <div>\n              <select class=\"form-control\" [(ngModel)]=\"floating.type\" name=\"type\">\n                <option [ngValue]=\"type\" *ngFor=\"let type of types\">{{type}}</option>\n              </select>\n            </div>\n          </div>\n\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Polisztirol sűrűség</label>\n            <div>\n              {{ typeMap[floating.type].density }} kg/m<sup>3</sup>\n            </div>\n          </div>\n\n          <!--\n          <div class=\"form-group d-flex flex-row justify-content-between align-items-center\">\n            <label class=\"m-0\">Polisztirol térfogat tömeg</label>\n            <div>\n              {{ typeMap[floating.type].density * floating.width * floating.length * floating.height | number:'1.2' }} kg\n            </div>\n          </div>\n          -->\n\n        </div>\n      </div>\n\n    </div>\n\n\n    <div class=\"flex-grow-1 container-3d right-panel-view shadow-lg\">\n\n      <floating-view [floating]=\"floating\" (onChange)=\"sizeChanged($event.floating)\"></floating-view>\n\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/floating-view/floating-view.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/floating-view/floating-view.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<canvas id=\"scene\" #scene touch-action=\"none\"></canvas>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/preview/preview.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/preview/preview.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"w-100\" id=\"preview3d\">\n  <building-floating-view [building]=\"building\" [floating]=\"floating\"></building-floating-view>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/result-container/result-container.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/result-container/result-container.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"preview\" class=\"w-100\">\n  <div id=\"preview-inner\">\n\n    <div class=\"py-5\" *ngIf=\"loading\">\n      <div class=\"text-center my-5\">\n        <span class=\"loading-anim\"></span>\n      </div>\n      <div class=\"text-center pt-4 text-bold\">\n        Eredmények számítása...\n      </div>\n    </div>\n    <div *ngIf=\"!loading\">\n    </div>\n\n    <iframe id=\"docview\" [class.d-none]=\"loading\"></iframe>\n\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/about-dialog/about-dialog.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/about-dialog/about-dialog.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal-header text-bold bg-primary text-white\">\n  <span><b>Ponton Terv</b> - Névjegy</span>\n</div>\n<div class=\"modal-body text-center text-bold\">\n\n  <div class=\"p-4\">\n\n    <h1 class=\"mb-4\">Ponton Terv</h1>\n    <div style=\"width: 380px; max-width: 100%; margin: 0 auto 40px\">\n      <p class=\"text-info mb-0\">Úszó Beton Platform Tervező Rendszer</p>\n      <p class=\"mb-3\">Program verzió: {{ version }}</p>\n\n      <p>A rendszer az S+H Portfolio Vagyonkezelő és Munkaerőgazdálkodási Zrt. tulajdona.<br/>Minden jog fenntartva!</p>\n\n      <p>A rendszer kialakításában közreműködtek: Katona László, Koch Bálint, Nagy Zoltán, Puskás Péter</p>\n    </div>\n    <button type=\"button\" class=\"btn btn-primary btn-long\" (click)=\"modal.close()\">Ok</button>\n  </div>\n\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/confirm-dialog/confirm-dialog.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/confirm-dialog/confirm-dialog.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal-header text-bold\" *ngIf=\"message\">\n  {{message}}\n</div>\n<div class=\"modal-body modal-body-dark\">\n  <div class=\"d-flex flex-row justify-content-end\">\n    <button type=\"button\" class=\"btn btn-default\" (click)=\"modal.dismiss()\" i18n>Mégsem</button>\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"ok()\" i18n>Ok</button>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/project-name-dialog/project-name-dialog.component.html":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/project-name-dialog/project-name-dialog.component.html ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal-header text-bold\">\n  Új projekt\n</div>\n<div class=\"modal-body text-bold\">\n\n  <form (submit)=\"modal.close(newProjectName)\">\n    <div class=\"form-group\">\n      <label>Terv neve</label>\n      <input name=\"name\" type=\"text\" class=\"form-control\" [(ngModel)]=\"newProjectName\" />\n    </div>\n\n    <div class=\"d-flex flex-row justify-content-end\">\n      <button type=\"submit\" class=\"btn btn-primary\">Ok</button>\n    </div>\n  </form>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/layouts/app-layout/app-layout.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/layouts/app-layout/app-layout.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ng-container *ngIf=\"afAuth.user | async as user\">\n  <nav class=\"navbar navbar-light bg-primary\">\n    <a class=\"navbar-brand text-white\" routerLink=\"/dashboard\"><b>Ponton</b>Terv</a>\n\n    <span class=\"ml-auto\">\n      <span class=\"text-white mr-3\">\n        <i class=\"fas fa-user mr-1\"></i>\n        {{ dataService.userInfo?.name }}\n      </span>\n      <a href=\"javascript:\" class=\"btn btn-primary\" (click)=\"logout()\">\n        <i class=\"fas fa-power-off\"></i>\n      </a>\n    </span>\n  </nav>\n  <router-outlet></router-outlet>\n\n  <span class=\"eu-logo\"></span>\n</ng-container>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/layouts/auth-layout/auth-layout.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/layouts/auth-layout/auth-layout.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/dashboard-page/dashboard-page.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/dashboard-page/dashboard-page.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container-fluid planbg py-3\">\n  <div class=\"p-4\">\n\n    <div class=\"d-flex mb-5 flex-row\">\n\n        <a routerLink=\"/project/create\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold mr-3\">\n          <span class=\"d-block mb-3\">\n            <i class=\"fas fa-3x fa-plus\"></i>\n          </span>\n          Új Ponton Terv készítés\n        </a>\n\n        <ng-container *ngIf=\"projects$.list | async as projects\">\n\n          <a routerLink=\"/projects/copy\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold mr-3\" [class.disabled]=\"!projects.length\">\n            <span class=\"d-block mb-3\">\n              <i class=\"fas fa-3x fa-copy\"></i>\n            </span>\n            Új Ponton Terv másolatból\n          </a>\n\n          <a routerLink=\"/projects/modify\" class=\"btn btn-dashboard btn-primary disabled p-3 py-4 text-bold\" [class.disabled]=\"!projects.length\">\n            <span class=\"d-block mb-3\">\n              <i class=\"fas fa-3x fa-edit\"></i>\n            </span>\n            Ponton Terv módosítása\n          </a>\n\n        </ng-container>\n\n    </div>\n    <div class=\"d-flex mb-5 flex-row\">\n\n      <a routerLink=\"/tech-settings\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold mr-3\" *ngIf=\"data.isAdmin\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-cog\"></i>\n        </span>\n        Technikai beállítások\n      </a>\n      <a href=\"javascript:\" class=\"btn btn-dashboard btn-primary disabled p-3 py-4 text-bold mr-3\" *ngIf=\"!data.isAdmin\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-cog\"></i>\n        </span>\n        Technikai beállítások\n      </a>\n\n      <a routerLink=\"/design-settings\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold mr-3\" *ngIf=\"data.isAdmin\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-pencil-ruler\"></i>\n        </span>\n        Tervezési beállítások\n      </a>\n      <a href=\"javascript:\"  class=\"btn btn-dashboard btn-primary disabled p-3 py-4 text-bold mr-3\" *ngIf=\"!data.isAdmin\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-pencil-ruler\"></i>\n        </span>\n        Tervezési beállítások\n      </a>\n\n      <a routerLink=\"/help\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-question\"></i>\n        </span>\n        Segítség\n      </a>\n\n    </div>\n    <div class=\"d-flex flex-row\">\n\n      <a routerLink=\"/users\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold mr-3\" *ngIf=\"data.isAdmin\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-users\"></i>\n        </span>\n        Felhasználó kezelés\n      </a>\n      <a href=\"javascript:\" class=\"btn btn-dashboard btn-primary disabled p-3 py-4 text-bold mr-3\" *ngIf=\"!data.isAdmin\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-users\"></i>\n        </span>\n        Felhasználó kezelés\n      </a>\n\n      <a href=\"javascript:\" (click)=\"about()\" class=\"btn btn-dashboard btn-primary p-3 py-4 text-bold\">\n        <span class=\"d-block mb-3\">\n          <i class=\"fas fa-3x fa-credit-card\"></i>\n        </span>\n        Névjegy\n      </a>\n\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/design-settings-page/design-settings-page.component.html":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/design-settings-page/design-settings-page.component.html ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-light bg-dark justify-content-start no-print\">\n  <a routerLink=\"/dashboard\" class=\"navbar-link text-white\"><i class=\"fas fa-home\"></i></a>\n  <i class=\"fas fa-chevron-right text-muted mx-3\"></i>\n  <span class=\"navbar-text text-white\">Tervezési beállítások</span>\n</nav>\n<div class=\"p-5\" *ngIf=\"designSettings$.obj | async as designSettings\">\n  <div class=\"form-horizontal\">\n\n    <div class=\"row\">\n      <div class=\"col-6\">\n\n        <div class=\"card mb-3\">\n          <div class=\"card-header\">\n            Felépítmény beállításai\n          </div>\n          <div class=\"card-body p-0\">\n\n            <table class=\"table mb-0\">\n              <thead>\n                <tr>\n                  <th>&nbsp;</th>\n                  <th>Alapértelmezett érték</th>\n                  <th>Minimum érték</th>\n                  <th>Maximum érték</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td><span class=\"singleline\">Tömege (tonna)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.building.weight\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.weight.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.weight.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Magassága (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.building.height\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.height.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.height.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Hossza (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.building.length\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.length.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.length.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Szélessége (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.building.width\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.width.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.width.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Területe (m<sup>2</sup>)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [value]=\"designSettings.project.building.width * designSettings.project.building.length\" readonly disabled /></td>\n                  <td><input type=\"number\" class=\"form-control\" [value]=\"designSettings.buildingSettings.width.min * designSettings.buildingSettings.length.min\" readonly disabled /></td>\n                  <td><input type=\"number\" class=\"form-control\" [value]=\"designSettings.buildingSettings.length.max * designSettings.buildingSettings.width.max\" readonly disabled /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Szabad perem szélessége (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.building.extraWidth\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.extraWidth.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.buildingSettings.extraWidth.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">1 napelem névleges teljesítménye (W)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.solarPower\" required /></td>\n                  <td>&nbsp;</td>\n                  <td>&nbsp;</td>\n                </tr>\n              </tbody>\n            </table>\n\n\n\n          </div>\n        </div>\n      </div>\n      <div class=\"col-6\">\n\n        <div class=\"card mb-3\">\n          <div class=\"card-header\">\n            Úszómű elem beállításai\n          </div>\n          <div class=\"card-body  p-0\">\n\n            <table class=\"table mb-0\">\n              <thead>\n                <tr>\n                  <th>&nbsp;</th>\n                  <th>Alapértelmezett érték</th>\n                  <th>Minimum érték</th>\n                  <th>Maximum érték</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td><span class=\"singleline\">Víz feletti része (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.floating.aboveWater\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.aboveWater.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.aboveWater.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Magassága (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.floating.height\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.height.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.height.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Hossza (méter)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.project.floating.length\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.length.min\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.length.max\" required /></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Betonfal vastagsága (cm x cm)</span></td>\n                  <td><select class=\"form-control\" [(ngModel)]=\"designSettings.project.floating.wallThickness\"><option *ngFor=\"let w of wallThicknessTypes\" [ngValue]=\"w\">{{w}}</option></select></td>\n                  <td><select class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.wallThickness.min\"><option *ngFor=\"let w of wallThicknessTypes\" [ngValue]=\"w\">{{w}}</option></select></td>\n                  <td><select class=\"form-control\" [(ngModel)]=\"designSettings.floatingSettings.wallThickness.max\"><option *ngFor=\"let w of wallThicknessTypes\" [ngValue]=\"w\">{{w}}</option></select></td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Merevítő korrekciós szorzó</span></td>\n                  <td>\n                    <span class=\"input-group\">\n                      <input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.mksz_percent\" required />\n                      <span class=\"input-group-append\">\n                        <span class=\"input-group-text\">%</span>\n                      </span>\n                    </span>\n                  </td>\n                  <td colspan=\"2\">&nbsp;</td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Polisztirol típus</span></td>\n                  <td><select class=\"form-control\" [(ngModel)]=\"designSettings.project.floating.type\"><option *ngFor=\"let w of types\" [ngValue]=\"w\">{{w}}</option></select></td>\n                  <td colspan=\"2\">&nbsp;</td>\n                </tr>\n                <tr>\n                  <td><span class=\"singleline\">Polisztirol sűrűség (kg/m<sup>3</sup>)</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [value]=\"designSettings.foamSettings[designSettings.project.floating.type].density\" disabled readonly /></td>\n                  <td colspan=\"2\">&nbsp;</td>\n                </tr>\n              </tbody>\n            </table>\n\n          </div>\n        </div>\n\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-4\">\n\n        <div class=\"card mb-3\">\n          <div class=\"card-header\">\n            Polisztirol beállításai\n          </div>\n          <div class=\"card-body  p-0\">\n\n            <table class=\"table mb-0\">\n              <thead>\n                <tr>\n                  <th>&nbsp;</th>\n                  <th>Sűrűség</th>\n                  <th>Egységár</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr *ngFor=\"let type of types\">\n                  <td><span class=\"singleline\">{{type}}</span></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.foamSettings[type].density\" required /></td>\n                  <td><input type=\"number\" class=\"form-control\" [(ngModel)]=\"designSettings.foamSettings[type].price\" required /></td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n  <div class=\"text-center\">\n    <a routerLink=\"/dashboard\" class=\"btn btn-lg btn-link\">Mégsem</a>\n    <button type=\"button\" class=\"btn btn-lg btn-primary\" (click)=\"save(designSettings)\">Beállítások mentése</button>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/edit-project-page/edit-project-page.component.html":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/edit-project-page/edit-project-page.component.html ***!
  \****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-light bg-dark justify-content-start no-print\">\n  <a routerLink=\"/dashboard\" class=\"navbar-link text-white\"><i class=\"fas fa-home\"></i></a>\n  <i class=\"fas fa-chevron-right text-muted mx-3\"></i>\n  <span class=\"navbar-text text-white\">{{pageTitle}}</span>\n  <span *ngIf=\"project\" class=\"navbar-text text-white ml-auto\">{{project.name}} - <em>{{ project.version || 1 }}. terv verzió</em></span>\n</nav>\n<div class=\"container-fluid py-3\" *ngIf=\"project\">\n\n  <ul class=\"nav nav-pills nav-fill steps mb-3 no-print\">\n    <li class=\"nav-item step\" *ngFor=\"let stepItem of steps\">\n      <a class=\"nav-link unclickable\" href=\"javascript:\" [class.active]=\"step >= stepItem.id\">\n        <span><span>{{stepItem.id}}</span></span>\n        {{stepItem.name}}\n      </a>\n    </li>\n  </ul>\n\n  <div class=\"step-content d-flex align-items-center justify-content-center mb-3\">\n    <app-design-building *ngIf=\"step===1\" [project]=\"project\" class=\"d-block w-100\"></app-design-building>\n    <app-design-floating *ngIf=\"step===2\" [project]=\"project\" class=\"d-block w-100\"></app-design-floating>\n    <app-preview *ngIf=\"step===3\" [project]=\"project\" class=\"d-block w-100\"></app-preview>\n    <app-result-container #results *ngIf=\"step===4\" [project]=\"project\" class=\"d-block w-100\"></app-result-container>\n  </div>\n\n  <div class=\"d-flex flex-row justify-content-left align-items-center no-print keep-left-distance\">\n    <button *ngIf=\"step > 1\" type=\"button\" class=\"btn btn-lg btn-warning text-bold uppercase\" (click)=\"prev()\"><i class=\"fas fa-chevron-left mr-2\"></i> Vissza</button>\n    <span class=\"ml-auto\">\n      <ng-container *ngIf=\"step < steps.length\">\n        <button type=\"button\" class=\"btn btn-lg btn-primary text-bold uppercase\" (click)=\"next()\">Tovább <i class=\"fas fa-chevron-right ml-2\"></i></button>\n      </ng-container>\n      <ng-container *ngIf=\"step === steps.length\">\n        <button type=\"button\" class=\"btn btn-lg btn-info text-bold uppercase mr-3\" (click)=\"print()\">Nyomtatás</button>\n        <button type=\"button\" class=\"btn btn-lg btn-success text-bold uppercase\" (click)=\"save()\">Mentés</button>\n      </ng-container>\n    </span>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/help-page/help-page.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/help-page/help-page.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-light bg-dark justify-content-start no-print\">\n  <a routerLink=\"/dashboard\" class=\"navbar-link text-white\"><i class=\"fas fa-home\"></i></a>\n  <i class=\"fas fa-chevron-right text-muted mx-3\"></i>\n  <span class=\"navbar-text text-white\">Segítség</span>\n</nav>\n<iframe id=\"help\" src=\"/assets/help.pdf\" class=\"full-page-iframe\" frameborder=\"no\"></iframe>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login-page/login-page.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login-page/login-page.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"full-page d-flex align-items-start align-items-md-center p-3 justify-content-center\">\n\n  <div class=\"card shadow-lg\">\n    <div class=\"card-header bg-primary text-white\">\n      <b>PontonTerv</b> - Bejelentkezés\n    </div>\n    <div class=\"card-body\">\n\n      <form class=\"form\" (submit)=\"login()\">\n\n        <div class=\"form-group\">\n          <label>Email cím</label>\n          <input type=\"email\" class=\"form-control\" name=\"email\" [(ngModel)]=\"user.email\" />\n        </div>\n\n        <div class=\"form-group\">\n          <label>Jelszó</label>\n          <input type=\"password\" class=\"form-control\" name=\"password\" [(ngModel)]=\"user.password\" />\n        </div>\n\n        <p *ngIf=\"loginError\" class=\"alert alert-danger\">Hibás email cím vagy jelszó.</p>\n\n        <div class=\"d-flex flex-row justify-content-between align-items-center\">\n          <a routerLink=\"/auth/signup\" class=\"mr-3\">Még nincs fiókom</a>\n          <span>\n            <button class=\"btn btn-info mr-1\" type=\"button\" (click)=\"loginWithGoogle()\"><i class=\"fab fa-google\"></i></button>\n            <button class=\"btn btn-primary\" type=\"submit\" [disabled]=\"!user.email || !user.password\">Bejelentkezés</button>\n          </span>\n        </div>\n\n      </form>\n\n    </div>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/projects-page/projects-page.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/projects-page/projects-page.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-light bg-dark justify-content-start no-print\">\n  <a routerLink=\"/dashboard\" class=\"navbar-link text-white\"><i class=\"fas fa-home\"></i></a>\n  <i class=\"fas fa-chevron-right text-muted mx-3\"></i>\n  <span class=\"navbar-text text-white\">{{ pageTitle }}</span>\n</nav>\n<div class=\"p-3\">\n\n  <ng-container *ngIf=\"projects$.list | async as projects\">\n    <div class=\"card\">\n      <table class=\"table table-striped mb-0\">\n        <thead>\n          <tr>\n            <th>Projekt név</th>\n            <th>Verzió</th>\n            <th>Létrehozva</th>\n            <th>Tervező</th>\n            <th>&nbsp;</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let project of projects\">\n            <td>{{project.name}}</td>\n            <td>{{project.version}}</td>\n            <td>{{project.createdAt | date}}</td>\n            <td>{{project.designer.name}}</td>\n            <td class=\"text-right\">\n              <a [routerLink]=\"['/project/copy', project.key]\" class=\"btn btn-primary\" *ngIf=\"action === 'copy'\">\n                <i class=\"fas fa-copy\"></i>\n              </a>\n              <a [routerLink]=\"['/project/modify', project.key]\" class=\"btn btn-primary\" *ngIf=\"action === 'modify'\">\n                <i class=\"fas fa-edit\"></i>\n              </a>\n\n              <button type=\"button\" class=\"btn btn-danger ml-3\" (click)=\"delete(project)\" *ngIf=\"action === 'modify'\">\n                <i class=\"fas fa-times\"></i>\n              </button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </ng-container>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/signup-page/signup-page.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/signup-page/signup-page.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"full-page d-flex align-items-start align-items-md-center p-3 justify-content-center\">\n\n  <div class=\"card shadow-lg\">\n    <div class=\"card-header bg-primary text-white\">\n      <b>PontonTerv</b> - Fiók létrehozása\n    </div>\n    <div class=\"card-body\">\n\n      <form class=\"form\" (submit)=\"signup()\" #frmSignup=\"ngForm\">\n\n        <div class=\"form-group\">\n          <label>Név</label>\n          <input type=\"text\" class=\"form-control\" name=\"name\" [(ngModel)]=\"user.name\" required />\n        </div>\n\n        <div class=\"form-group\">\n          <label>Email cím</label>\n          <input type=\"email\" class=\"form-control\" name=\"email\" [(ngModel)]=\"user.email\" required />\n        </div>\n\n        <div class=\"form-group\">\n          <label>Jelszó</label>\n          <input type=\"password\" class=\"form-control\" name=\"password\" [(ngModel)]=\"user.password\" required />\n        </div>\n\n        <div class=\"form-group\">\n          <label>Jelszó megerősítése</label>\n          <input type=\"password\" class=\"form-control\" name=\"password2\" [(ngModel)]=\"user.password2\" required #password2=\"ngModel\" />\n        </div>\n\n        <p *ngIf=\"password2.touched && user.password !== user.password2\" class=\"alert alert-danger\">A megadott jelszavak eltérnek!</p>\n        <p *ngIf=\"signupError\" class=\"alert alert-danger\">Hiba történt a fiók létrehozása közben.</p>\n\n        <div class=\"d-flex flex-row justify-content-between align-items-center\">\n          <a routerLink=\"/auth/login\" class=\"mr-3\">Már van fiókom</a>\n          <button class=\"btn btn-primary\" type=\"submit\" [disabled]=\"frmSignup.invalid\">Regisztráció</button>\n        </div>\n\n      </form>\n\n    </div>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/tech-settings-page/tech-settings-page.component.html":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/tech-settings-page/tech-settings-page.component.html ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-light bg-dark justify-content-start no-print\">\n  <a routerLink=\"/dashboard\" class=\"navbar-link text-white\"><i class=\"fas fa-home\"></i></a>\n  <i class=\"fas fa-chevron-right text-muted mx-3\"></i>\n  <span class=\"navbar-text text-white\">Technikai beállítások</span>\n</nav>\n<div class=\"p-5\">\n\n  <div class=\"card w-700\">\n    <div class=\"card-body\">\n      <form #frmSettings=\"ngForm\" class=\"form-horizontal\" (submit)=\"save()\">\n\n        <div class=\"form-group\">\n          <label>Felhasználó inaktivitás maximális ideje</label>\n          <span class=\"input-group\">\n            <input type=\"number\" class=\"form-control\" [(ngModel)]=\"settings.inactivity\" name=\"inactivity\" min=\"0\" max=\"20000\" required />\n            <span class=\"input-group-append\">\n              <span class=\"input-group-text\">\n                perc\n              </span>\n            </span>\n          </span>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Eseménynapló bejegyzések elévülési ideje</label>\n          <span class=\"input-group\">\n            <input type=\"number\" class=\"form-control\" [(ngModel)]=\"settings.logExpiration\" name=\"logExpiration\" min=\"0\" max=\"20000\" required />\n            <span class=\"input-group-append\">\n              <span class=\"input-group-text\">\n                perc\n              </span>\n            </span>\n          </span>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Automatikus archiválás időintervalluma</label>\n          <span class=\"input-group\">\n            <input type=\"number\" class=\"form-control\" [(ngModel)]=\"settings.archiveDays\" name=\"archiveDays\" min=\"0\" max=\"365\" required />\n            <span class=\"input-group-append\">\n              <span class=\"input-group-text\">\n                perc\n              </span>\n            </span>\n          </span>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Automatikus archiválás URL</label>\n          <span class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"settings.archiveHost\" name=\"archiveHost\" required />\n          </span>\n        </div>\n\n        <div class=\"d-flex flex-row justify-content-end\">\n          <a routerLink=\"/dashboard\" class=\"btn btn-link\">Mégsem</a>\n          <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"frmSettings.invalid\">Ok</button>\n        </div>\n\n      </form>\n    </div>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/users-page/users-page.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/users-page/users-page.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-light bg-dark justify-content-start no-print\">\n  <a routerLink=\"/dashboard\" class=\"navbar-link text-white\"><i class=\"fas fa-home\"></i></a>\n  <i class=\"fas fa-chevron-right text-muted mx-3\"></i>\n  <span class=\"navbar-text text-white\">Felhasználó kezelés</span>\n</nav>\n<div class=\"p-3\">\n\n  <ng-container *ngIf=\"users$.list | async as users\">\n    <div class=\"card\">\n      <table class=\"table table-striped mb-0\">\n        <thead>\n          <tr>\n            <th>Név</th>\n            <th>Email</th>\n            <th>Létrehozva</th>\n            <th class=\"text-center\">Aktív</th>\n            <th>Jogosultság</th>\n            <th>&nbsp;</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let user of users\">\n            <tr *ngIf=\"!user.deleted\">\n              <td>\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"user.name\" (change)=\"changed[user.key]=true\" [readonly]=\"!data.isAdmin\">\n              </td>\n              <td>\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"user.email\" (change)=\"changed[user.key]=true\" [readonly]=\"!data.isAdmin\">\n              </td>\n              <td>\n                {{ user.createdAt | date }}\n              </td>\n              <td class=\"text-center\">\n                <input class=\"checkbox\" type=\"checkbox\" [(ngModel)]=\"user.enabled\" (change)=\"changed[user.key]=true\" [disabled]=\"!data.isAdmin || user.key === data.user.uid\">\n              </td>\n              <td>\n                <select class=\"form-control\" [(ngModel)]=\"user.role\" (change)=\"changed[user.key]=true\" [disabled]=\"!data.isAdmin || user.key === data.user.uid\">\n                  <option *ngFor=\"let role of roles\" [ngValue]=\"role.id\">{{role.name}}</option>\n                </select>\n              </td>\n              <td class=\"text-right\">\n                <button type=\"button\" class=\"btn btn-primary mr-3\" [disabled]=\"!changed[user.key]\" (click)=\"save(user)\" *ngIf=\"data.isAdmin\">\n                  <i class=\"fas fa-save\"></i>\n                </button>\n\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"delete(user)\" *ngIf=\"data.isAdmin\">\n                  <i class=\"fas fa-times\"></i>\n                </button>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </div>\n  </ng-container>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_fire_auth_guard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth-guard */ "./node_modules/@angular/fire/auth-guard/es2015/index.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _layouts_app_layout_app_layout_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./layouts/app-layout/app-layout.component */ "./src/app/layouts/app-layout/app-layout.component.ts");
/* harmony import */ var _layouts_auth_layout_auth_layout_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./layouts/auth-layout/auth-layout.component */ "./src/app/layouts/auth-layout/auth-layout.component.ts");
/* harmony import */ var _pages_login_page_login_page_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./pages/login-page/login-page.component */ "./src/app/pages/login-page/login-page.component.ts");
/* harmony import */ var _pages_signup_page_signup_page_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./pages/signup-page/signup-page.component */ "./src/app/pages/signup-page/signup-page.component.ts");
/* harmony import */ var _pages_dashboard_page_dashboard_page_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./pages/dashboard-page/dashboard-page.component */ "./src/app/pages/dashboard-page/dashboard-page.component.ts");
/* harmony import */ var _pages_users_page_users_page_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pages/users-page/users-page.component */ "./src/app/pages/users-page/users-page.component.ts");
/* harmony import */ var _pages_tech_settings_page_tech_settings_page_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pages/tech-settings-page/tech-settings-page.component */ "./src/app/pages/tech-settings-page/tech-settings-page.component.ts");
/* harmony import */ var _pages_design_settings_page_design_settings_page_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pages/design-settings-page/design-settings-page.component */ "./src/app/pages/design-settings-page/design-settings-page.component.ts");
/* harmony import */ var _pages_help_page_help_page_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pages/help-page/help-page.component */ "./src/app/pages/help-page/help-page.component.ts");
/* harmony import */ var _pages_projects_page_projects_page_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pages/projects-page/projects-page.component */ "./src/app/pages/projects-page/projects-page.component.ts");
/* harmony import */ var _pages_edit_project_page_edit_project_page_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./pages/edit-project-page/edit-project-page.component */ "./src/app/pages/edit-project-page/edit-project-page.component.ts");
















const redirectUnauthorizedToLogin = () => Object(_angular_fire_auth_guard__WEBPACK_IMPORTED_MODULE_3__["redirectUnauthorizedTo"])(['/auth/login']);
const redirectLoggedInToDashboard = () => Object(_angular_fire_auth_guard__WEBPACK_IMPORTED_MODULE_3__["redirectLoggedInTo"])(['/dashboard']);
const routes = [
    { path: '', component: _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"], children: [
            { path: 'auth', component: _layouts_auth_layout_auth_layout_component__WEBPACK_IMPORTED_MODULE_6__["AuthLayoutComponent"], canActivate: [_angular_fire_auth_guard__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuthGuard"]], data: { authGuardPipe: redirectLoggedInToDashboard }, children: [
                    { path: 'login', component: _pages_login_page_login_page_component__WEBPACK_IMPORTED_MODULE_7__["LoginPageComponent"] },
                    { path: 'signup', component: _pages_signup_page_signup_page_component__WEBPACK_IMPORTED_MODULE_8__["SignupPageComponent"] },
                ] },
            { path: '', component: _layouts_app_layout_app_layout_component__WEBPACK_IMPORTED_MODULE_5__["AppLayoutComponent"], canActivate: [_angular_fire_auth_guard__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuthGuard"]], data: { authGuardPipe: redirectUnauthorizedToLogin }, children: [
                    { path: 'dashboard', component: _pages_dashboard_page_dashboard_page_component__WEBPACK_IMPORTED_MODULE_9__["DashboardPageComponent"] },
                    { path: 'project/:projectEditMode/:id', component: _pages_edit_project_page_edit_project_page_component__WEBPACK_IMPORTED_MODULE_15__["EditProjectPageComponent"] },
                    { path: 'users', component: _pages_users_page_users_page_component__WEBPACK_IMPORTED_MODULE_10__["UsersPageComponent"] },
                    { path: 'tech-settings', component: _pages_tech_settings_page_tech_settings_page_component__WEBPACK_IMPORTED_MODULE_11__["TechSettingsPageComponent"] },
                    { path: 'design-settings', component: _pages_design_settings_page_design_settings_page_component__WEBPACK_IMPORTED_MODULE_12__["DesignSettingsPageComponent"] },
                    { path: 'help', component: _pages_help_page_help_page_component__WEBPACK_IMPORTED_MODULE_13__["HelpPageComponent"] },
                    { path: 'projects/:action', component: _pages_projects_page_projects_page_component__WEBPACK_IMPORTED_MODULE_14__["ProjectsPageComponent"] },
                    { path: 'project/create', pathMatch: 'full', redirectTo: 'project/create/new' },
                    { path: '**', pathMatch: 'full', redirectTo: 'dashboard' }
                ] },
        ] },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_fire_auth_guard__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuthGuardModule"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/fire */ "./node_modules/@angular/fire/es2015/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_database__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/fire/database */ "./node_modules/@angular/fire/database/es2015/index.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _layouts_app_layout_app_layout_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./layouts/app-layout/app-layout.component */ "./src/app/layouts/app-layout/app-layout.component.ts");
/* harmony import */ var _layouts_auth_layout_auth_layout_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./layouts/auth-layout/auth-layout.component */ "./src/app/layouts/auth-layout/auth-layout.component.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _pages_login_page_login_page_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pages/login-page/login-page.component */ "./src/app/pages/login-page/login-page.component.ts");
/* harmony import */ var _pages_signup_page_signup_page_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./pages/signup-page/signup-page.component */ "./src/app/pages/signup-page/signup-page.component.ts");
/* harmony import */ var _pages_dashboard_page_dashboard_page_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./pages/dashboard-page/dashboard-page.component */ "./src/app/pages/dashboard-page/dashboard-page.component.ts");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");
/* harmony import */ var _babylonjs_loaders__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babylonjs/loaders */ "./node_modules/@babylonjs/loaders/index.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _services_dialog_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./services/dialog.service */ "./src/app/services/dialog.service.ts");
/* harmony import */ var _pages_users_page_users_page_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./pages/users-page/users-page.component */ "./src/app/pages/users-page/users-page.component.ts");
/* harmony import */ var _pages_tech_settings_page_tech_settings_page_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./pages/tech-settings-page/tech-settings-page.component */ "./src/app/pages/tech-settings-page/tech-settings-page.component.ts");
/* harmony import */ var _pages_design_settings_page_design_settings_page_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./pages/design-settings-page/design-settings-page.component */ "./src/app/pages/design-settings-page/design-settings-page.component.ts");
/* harmony import */ var _pages_help_page_help_page_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./pages/help-page/help-page.component */ "./src/app/pages/help-page/help-page.component.ts");
/* harmony import */ var _pages_projects_page_projects_page_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./pages/projects-page/projects-page.component */ "./src/app/pages/projects-page/projects-page.component.ts");
/* harmony import */ var _pages_edit_project_page_edit_project_page_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./pages/edit-project-page/edit-project-page.component */ "./src/app/pages/edit-project-page/edit-project-page.component.ts");
/* harmony import */ var _dialogs_project_name_dialog_project_name_dialog_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./dialogs/project-name-dialog/project-name-dialog.component */ "./src/app/dialogs/project-name-dialog/project-name-dialog.component.ts");
/* harmony import */ var _dialogs_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./dialogs/confirm-dialog/confirm-dialog.component */ "./src/app/dialogs/confirm-dialog/confirm-dialog.component.ts");
/* harmony import */ var _components_design_building_design_building_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/design-building/design-building.component */ "./src/app/components/design-building/design-building.component.ts");
/* harmony import */ var _components_design_floating_design_floating_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/design-floating/design-floating.component */ "./src/app/components/design-floating/design-floating.component.ts");
/* harmony import */ var _components_preview_preview_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/preview/preview.component */ "./src/app/components/preview/preview.component.ts");
/* harmony import */ var _components_result_container_result_container_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/result-container/result-container.component */ "./src/app/components/result-container/result-container.component.ts");
/* harmony import */ var _components_building_view_building_view_component__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./components/building-view/building-view.component */ "./src/app/components/building-view/building-view.component.ts");
/* harmony import */ var _components_floating_view_floating_view_component__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/floating-view/floating-view.component */ "./src/app/components/floating-view/floating-view.component.ts");
/* harmony import */ var _components_building_floating_view_building_floating_view_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/building-floating-view/building-floating-view.component */ "./src/app/components/building-floating-view/building-floating-view.component.ts");
/* harmony import */ var _dialogs_about_dialog_about_dialog_component__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./dialogs/about-dialog/about-dialog.component */ "./src/app/dialogs/about-dialog/about-dialog.component.ts");





































_babylonjs_core__WEBPACK_IMPORTED_MODULE_17__["SceneLoader"].RegisterPlugin(new _babylonjs_loaders__WEBPACK_IMPORTED_MODULE_18__["OBJFileLoader"]());
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_13__["AppComponent"],
            _pages_login_page_login_page_component__WEBPACK_IMPORTED_MODULE_14__["LoginPageComponent"],
            _pages_signup_page_signup_page_component__WEBPACK_IMPORTED_MODULE_15__["SignupPageComponent"],
            _pages_dashboard_page_dashboard_page_component__WEBPACK_IMPORTED_MODULE_16__["DashboardPageComponent"],
            _layouts_app_layout_app_layout_component__WEBPACK_IMPORTED_MODULE_11__["AppLayoutComponent"],
            _layouts_auth_layout_auth_layout_component__WEBPACK_IMPORTED_MODULE_12__["AuthLayoutComponent"],
            _pages_users_page_users_page_component__WEBPACK_IMPORTED_MODULE_21__["UsersPageComponent"],
            _pages_tech_settings_page_tech_settings_page_component__WEBPACK_IMPORTED_MODULE_22__["TechSettingsPageComponent"],
            _pages_design_settings_page_design_settings_page_component__WEBPACK_IMPORTED_MODULE_23__["DesignSettingsPageComponent"],
            _pages_help_page_help_page_component__WEBPACK_IMPORTED_MODULE_24__["HelpPageComponent"],
            _pages_projects_page_projects_page_component__WEBPACK_IMPORTED_MODULE_25__["ProjectsPageComponent"],
            _pages_edit_project_page_edit_project_page_component__WEBPACK_IMPORTED_MODULE_26__["EditProjectPageComponent"],
            _dialogs_project_name_dialog_project_name_dialog_component__WEBPACK_IMPORTED_MODULE_27__["ProjectNameDialogComponent"],
            _components_design_building_design_building_component__WEBPACK_IMPORTED_MODULE_29__["DesignBuildingComponent"],
            _components_design_floating_design_floating_component__WEBPACK_IMPORTED_MODULE_30__["DesignFloatingComponent"],
            _components_preview_preview_component__WEBPACK_IMPORTED_MODULE_31__["PreviewComponent"],
            _components_result_container_result_container_component__WEBPACK_IMPORTED_MODULE_32__["ResultContainerComponent"],
            _components_building_view_building_view_component__WEBPACK_IMPORTED_MODULE_33__["BuildingViewComponent"],
            _components_floating_view_floating_view_component__WEBPACK_IMPORTED_MODULE_34__["FloatingViewComponent"],
            _components_building_floating_view_building_floating_view_component__WEBPACK_IMPORTED_MODULE_35__["BuildingFloatingViewComponent"],
            _dialogs_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_28__["ConfirmDialogComponent"],
            _dialogs_about_dialog_about_dialog_component__WEBPACK_IMPORTED_MODULE_36__["AboutDialogComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormsModule"],
            _angular_fire__WEBPACK_IMPORTED_MODULE_4__["AngularFireModule"].initializeApp(_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].firebase),
            _angular_fire_auth__WEBPACK_IMPORTED_MODULE_5__["AngularFireAuthModule"],
            _angular_fire_database__WEBPACK_IMPORTED_MODULE_6__["AngularFireDatabaseModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_10__["AppRoutingModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_9__["HttpClientModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_7__["NgbModule"]
        ],
        entryComponents: [
            _dialogs_project_name_dialog_project_name_dialog_component__WEBPACK_IMPORTED_MODULE_27__["ProjectNameDialogComponent"],
            _dialogs_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_28__["ConfirmDialogComponent"],
            _dialogs_about_dialog_about_dialog_component__WEBPACK_IMPORTED_MODULE_36__["AboutDialogComponent"]
        ],
        providers: [
            _services_data_service__WEBPACK_IMPORTED_MODULE_19__["DataService"],
            _services_dialog_service__WEBPACK_IMPORTED_MODULE_20__["DialogService"]
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_13__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/building-floating-view/building-floating-view.component.scss":
/*!*****************************************************************************************!*\
  !*** ./src/app/components/building-floating-view/building-floating-view.component.scss ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("canvas {\n  width: 100%;\n  height: 100%;\n  max-height: calc(100vh - 21rem);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvY29tcG9uZW50cy9idWlsZGluZy1mbG9hdGluZy12aWV3L2J1aWxkaW5nLWZsb2F0aW5nLXZpZXcuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvYnVpbGRpbmctZmxvYXRpbmctdmlldy9idWlsZGluZy1mbG9hdGluZy12aWV3LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLFlBQUE7RUFDQSwrQkFBQTtBQ0NGIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9idWlsZGluZy1mbG9hdGluZy12aWV3L2J1aWxkaW5nLWZsb2F0aW5nLXZpZXcuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJjYW52YXMge1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoIC0gMjFyZW0pO1xufVxuIiwiY2FudmFzIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgbWF4LWhlaWdodDogY2FsYygxMDB2aCAtIDIxcmVtKTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/building-floating-view/building-floating-view.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/components/building-floating-view/building-floating-view.component.ts ***!
  \***************************************************************************************/
/*! exports provided: BuildingFloatingViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildingFloatingViewComponent", function() { return BuildingFloatingViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");
/* harmony import */ var _lib_floating__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/floating */ "./src/app/lib/floating.ts");
/* harmony import */ var _lib_building__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../lib/building */ "./src/app/lib/building.ts");




//import { FloatingEdge } from '../../lib/floating-edge';

let BuildingFloatingViewComponent = class BuildingFloatingViewComponent {
    constructor(zone) {
        this.zone = zone;
    }
    ngAfterViewInit() {
        this.renderScene();
    }
    ngOnDestroy() {
        if (this.scene) {
            this.scene.dispose();
            this.scene = null;
        }
    }
    renderScene() {
        if (this.scene) {
            this.scene.dispose();
            this.scene = null;
        }
        if (!this.floating) {
            return;
        }
        const canvas = this.sceneElement.nativeElement;
        const engine = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Engine"](canvas);
        this.scene = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Scene"](engine);
        this.scene.clearColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Color4"](0.5, 0.6, 0.8);
        var hdrTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["HDRCubeTexture"]("/assets/textures/environment2.hdr", this.scene, 128);
        hdrTexture.gammaSpace = false;
        this.scene.environmentTexture = hdrTexture;
        var camera = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ArcRotateCamera"]("Camera", 3.74, 2.0, 40, new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, 0), this.scene);
        this.scene.activeCamera.attachControl(canvas);
        var building = new _lib_building__WEBPACK_IMPORTED_MODULE_4__["Building"](this.scene, this.building);
        building.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, this.building.height / 2 + this.floating.aboveWater, 0);
        //var rows, cols, rotation, w, l, ow, ol;
        let buildingWidth = this.building.width + this.building.extraWidth;
        let buildingLength = this.building.length + this.building.extraWidth;
        let qw1, ql1, qw2, ql2, qp1 = 0, qp2 = 0;
        if (this.floating.useLength2) {
            qw1 = Math.ceil(buildingWidth / this.floating.width);
            ql1 = Math.ceil((buildingLength - 2 * this.floating.length2) / this.floating.length);
            qp1 = qw1 * 2;
            qw2 = Math.ceil((buildingWidth - 2 * this.floating.length2) / this.floating.length);
            ql2 = Math.ceil(buildingLength / this.floating.width);
            qp2 = ql2 * 2;
        }
        else {
            qw1 = Math.ceil(buildingWidth / this.floating.width);
            ql1 = Math.ceil(buildingLength / this.floating.length);
            qw2 = Math.ceil(buildingWidth / this.floating.length);
            ql2 = Math.ceil(buildingLength / this.floating.width);
        }
        let totalWidth, totalLength; //, floatingEdge1, floatingEdge2;
        let floatings = [];
        if (qw1 * ql1 + qp1 > qw2 * ql2 + qp2) {
            totalWidth = qw2 * this.floating.length + 2 * (this.floating.useLength2 ? this.floating.length2 : 0);
            totalLength = ql2 * this.floating.width;
            let wrapperBox1 = _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].CreateBox("wrapperBox", { height: 1, width: 1, depth: 1 }, this.scene);
            wrapperBox1.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["StandardMaterial"]("transparent", this.scene);
            wrapperBox1.material.alpha = 0;
            wrapperBox1.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -this.floating.height / 2 + this.floating.aboveWater, 0);
            wrapperBox1.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](totalWidth, this.floating.height, totalLength);
            wrapperBox1.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, Math.PI / 2, 0);
            //floatingEdge1 = new FloatingEdge(this.scene, wrapperBox1, -1);
            //floatingEdge2 = new FloatingEdge(this.scene, wrapperBox1, 1);
            let rowMax = qw2 + (this.floating.useLength2 ? 2 : 0);
            let x = -totalWidth / 2;
            for (let row = 0; row < rowMax; row++) {
                let y = -totalLength / 2;
                let l = (row === 0 || row === rowMax - 1) && this.floating.useLength2 ? this.floating.length2 : this.floating.length;
                let w = this.floating.width;
                for (let col = 0; col < ql2; col++) {
                    let fconfig = Object.assign({}, this.floating, { width: l, length: w });
                    var floating = new _lib_floating__WEBPACK_IMPORTED_MODULE_3__["Floating"](this.scene, fconfig);
                    floating.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](y + w / 2, -this.floating.height / 2 + this.floating.aboveWater, x + l / 2);
                    floating.resize(fconfig, floating.controlMesh.position);
                    floatings.push({ floating, config: fconfig });
                    y += w;
                }
                x += l;
            }
        }
        else {
            totalWidth = qw1 * this.floating.width;
            totalLength = ql1 * this.floating.length + 2 * (this.floating.useLength2 ? this.floating.length2 : 0);
            let wrapperBox1 = _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].CreateBox("wrapperBox", { height: 1, width: 1, depth: 1 }, this.scene);
            wrapperBox1.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["StandardMaterial"]("transparent", this.scene);
            wrapperBox1.material.alpha = 0;
            wrapperBox1.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -this.floating.height / 2 + this.floating.aboveWater, 0);
            wrapperBox1.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](totalLength, this.floating.height, totalWidth);
            //floatingEdge1 = new FloatingEdge(this.scene, wrapperBox1, -1);
            //floatingEdge2 = new FloatingEdge(this.scene, wrapperBox1, 1);
            let rowMax = ql1 + (this.floating.useLength2 ? 2 : 0);
            let x = -totalLength / 2;
            for (let row = 0; row < rowMax; row++) {
                let y = -totalWidth / 2;
                let l = (row === 0 || row === rowMax - 1) && this.floating.useLength2 ? this.floating.length2 : this.floating.length;
                let w = this.floating.width;
                for (let col = 0; col < qw1; col++) {
                    let fconfig = Object.assign({}, this.floating, { width: w, length: l });
                    var floating = new _lib_floating__WEBPACK_IMPORTED_MODULE_3__["Floating"](this.scene, fconfig);
                    floating.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](x + l / 2, -this.floating.height / 2 + this.floating.aboveWater, y + w / 2);
                    floating.resize(fconfig, floating.controlMesh.position);
                    floatings.push({ floating, config: fconfig });
                    y += w;
                }
                x += l;
            }
        }
        this.floating.total = floatings.length;
        /* */
        var waterTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Texture"]("/assets/textures/waterbump.png", this.scene);
        waterTexture.vScale = waterTexture.uScale = 200.0;
        var waterMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["PBRMaterial"]("waterMaterial", this.scene);
        waterMaterial.backFaceCulling = false;
        waterMaterial.albedoTexture = waterTexture;
        waterMaterial.metallic = 0.1;
        waterMaterial.roughness = 0;
        waterMaterial.directIntensity = 1.0;
        waterMaterial.environmentIntensity = 0.1;
        waterMaterial.cameraExposure = 0.66;
        waterMaterial.cameraContrast = 1.66;
        waterMaterial.microSurface = 1;
        waterMaterial.reflectivityColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Color3"](1.0, 1.0, 1.0);
        waterMaterial.alpha = 0.6;
        var water = _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Mesh"].CreateGround("water", 2000, 2000, 32, this.scene, false);
        water.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, 0);
        water.material = waterMaterial;
        var groundTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Texture"]("/assets/textures/sand.jpg", this.scene);
        groundTexture.vScale = groundTexture.uScale = 200.0;
        var groundMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["PBRMaterial"]("groundMaterial", this.scene);
        groundMaterial.albedoTexture = groundTexture;
        groundMaterial.metallic = 0;
        groundMaterial.roughness = 0;
        groundMaterial.reflectionColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Color3"](0.2, 0.2, 0.2);
        var ground = _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Mesh"].CreateGround("ground", 2000, 2000, 32, this.scene, false);
        ground.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -50, 0);
        ground.material = groundMaterial;
        // Edges
        _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].CreateBox("s1", { height: 50, width: 2000, depth: 10 }, this.scene).position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -25, -1000);
        _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].CreateBox("s2", { height: 50, width: 2000, depth: 10 }, this.scene).position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -25, 1000);
        _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].CreateBox("s3", { height: 50, width: 10, depth: 2000 }, this.scene).position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](-1000, -25, 0);
        _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].CreateBox("s4", { height: 50, width: 10, depth: 2000 }, this.scene).position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](1000, -25, 0);
        /* */
        engine.runRenderLoop(() => {
            if (!this.scene)
                return;
            //if (camera.radius > 70)    camera.radius = 70;
            //if (camera.radius < 20)    camera.radius = 20;
            /*if (floatingEdge1.edge){
              floatingEdge1.edge.scaling = new Vector3(1, 1, 0.3 * 2.5 / totalLength);
            }
            if (floatingEdge2.edge){
              floatingEdge2.edge.scaling = new Vector3(1, 1, 0.3 * 2.5 / totalLength);
            }*/
            /*for (let f of floatings){
              f.floating.resize(f.config);
            }*/
            building.resize(this.building, building.controlMesh.position);
            this.scene.render();
        });
        window.addEventListener("resize", function () {
            try {
                engine.resize();
            }
            catch (e) { }
        });
    }
};
BuildingFloatingViewComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BuildingFloatingViewComponent.prototype, "floating", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BuildingFloatingViewComponent.prototype, "building", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('scene', { static: true })
], BuildingFloatingViewComponent.prototype, "sceneElement", void 0);
BuildingFloatingViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'building-floating-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./building-floating-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/building-floating-view/building-floating-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./building-floating-view.component.scss */ "./src/app/components/building-floating-view/building-floating-view.component.scss")).default]
    })
], BuildingFloatingViewComponent);



/***/ }),

/***/ "./src/app/components/building-view/building-view.component.scss":
/*!***********************************************************************!*\
  !*** ./src/app/components/building-view/building-view.component.scss ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("canvas {\n  width: 100%;\n  height: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvY29tcG9uZW50cy9idWlsZGluZy12aWV3L2J1aWxkaW5nLXZpZXcuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvYnVpbGRpbmctdmlldy9idWlsZGluZy12aWV3LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLFlBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvYnVpbGRpbmctdmlldy9idWlsZGluZy12aWV3LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiY2FudmFzIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbn1cbiIsImNhbnZhcyB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/building-view/building-view.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/building-view/building-view.component.ts ***!
  \*********************************************************************/
/*! exports provided: BuildingViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildingViewComponent", function() { return BuildingViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");
/* harmony import */ var _lib_building__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/building */ "./src/app/lib/building.ts");




let BuildingViewComponent = class BuildingViewComponent {
    constructor(zone) {
        this.zone = zone;
        this.onChange = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.isDragging = false;
    }
    ngAfterViewInit() {
        this.renderScene();
    }
    ngOnDestroy() {
        if (this.scene) {
            this.scene.dispose();
            this.scene = null;
        }
    }
    renderScene() {
        if (this.scene) {
            this.scene.dispose();
            this.scene = null;
            this.isDragging = false;
        }
        if (!this.building) {
            return;
        }
        const canvas = this.sceneElement.nativeElement;
        const engine = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Engine"](canvas);
        this.scene = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Scene"](engine);
        this.scene.clearColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Color4"](1.0, 1.0, 1.0);
        var hdrTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["HDRCubeTexture"]("/assets/textures/environment2.hdr", this.scene, 128);
        hdrTexture.gammaSpace = false;
        this.scene.environmentTexture = hdrTexture;
        var camera = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ArcRotateCamera"]("Camera", 3.74, 1.3, 30, new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, 0), this.scene);
        this.scene.activeCamera.attachControl(canvas);
        var building = new _lib_building__WEBPACK_IMPORTED_MODULE_3__["Building"](this.scene, this.building, true);
        //--------------------------------------------------------------------------
        // resize building
        let controls = [
            { field: 'controlMeshTop', change: 'y', factor: 1 },
            { field: 'controlMeshBottom', change: 'y', factor: -1 },
            { field: 'controlMeshLeft', change: 'x', factor: -1 },
            { field: 'controlMeshRight', change: 'x', factor: 1 },
            { field: 'controlMeshFront', change: 'z', factor: -1 },
            { field: 'controlMeshBack', change: 'z', factor: 1 },
        ];
        for (let control of controls) {
            let dragger = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["PointerDragBehavior"]();
            let draggedScale;
            dragger.onDragStartObservable.add((event) => {
                this.isDragging = true;
                building[control.field].material.alpha = 0.1;
            });
            dragger.onDragObservable.add((event) => {
                let delta;
                switch (control.change) {
                    case 'x':
                        delta = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](event.delta.x * control.factor, 0, 0);
                        break;
                    case 'y':
                        delta = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, event.delta.y * control.factor, 0);
                        break;
                    case 'z':
                        delta = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, event.delta.z * control.factor);
                        break;
                }
                building.controlMesh.scaling = draggedScale = building.controlMesh.scaling.add(delta);
                this.zone.run(() => {
                    this.onChange.next({ building: {
                            width: Math.round(building.controlMesh.scaling.z * 2) / 2,
                            height: Math.round(building.controlMesh.scaling.y * 2) / 2,
                            length: Math.round(building.controlMesh.scaling.x * 2) / 2
                        } });
                });
            });
            dragger.onDragEndObservable.add((event) => {
                if (this.isDragging) {
                    this.zone.run(() => {
                        if (draggedScale) {
                            building.controlMesh.scaling = draggedScale;
                            /*
                            this.building.length = Math.round(building.controlMesh.scaling.x);
                            this.building.height = Math.round(building.controlMesh.scaling.y);
                            this.building.width = Math.round(building.controlMesh.scaling.z);
                            */
                            this.onChange.next({ building: {
                                    width: Math.round(building.controlMesh.scaling.z * 2) / 2,
                                    height: Math.round(building.controlMesh.scaling.y * 2) / 2,
                                    length: Math.round(building.controlMesh.scaling.x * 2) / 2
                                } });
                        }
                        this.isDragging = false;
                        building[control.field].material.alpha = 0;
                    });
                }
            });
            dragger.moveAttached = false;
            building[control.field].isPickable = true;
            building[control.field].actionManager = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ActionManager"](this.scene);
            building[control.field].actionManager.registerAction(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ExecuteCodeAction"](_babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ActionManager"].OnPointerOverTrigger, (ev) => {
                if (!this.isDragging) {
                    building[control.field].material.alpha = 0.1;
                }
            }));
            building[control.field].actionManager.registerAction(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ExecuteCodeAction"](_babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ActionManager"].OnPointerOutTrigger, (ev) => {
                if (!this.isDragging) {
                    building[control.field].material.alpha = 0.0;
                }
            }));
            building[control.field].addBehavior(dragger);
        }
        //--------------------------------------------------------------------------
        engine.runRenderLoop(() => {
            if (!this.scene)
                return;
            if (!this.isDragging) {
                building.controlMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](this.building.length, this.building.height, this.building.width);
            }
            if (building.labels['width']) {
                building.labels['width'].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -this.building.height / 2 - 1.2, -this.building.width / 2 - 0.2);
                building.labelTexts['width'].text = '' + this.building.length + ' m';
                building.labels['height'].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](this.building.length / 2 + 0.5, -0.2, -this.building.width / 2 - 1);
                building.labelTexts['height'].text = '' + this.building.height + ' m';
                building.labels['length'].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](-this.building.length / 2 - 1.2, -this.building.height / 2 - 0.6, 0);
                building.labelTexts['length'].text = '' + this.building.width + ' m';
            }
            building.resize(this.building);
            this.scene.render();
        });
        window.addEventListener("resize", function () {
            try {
                engine.resize();
            }
            catch (e) { }
        });
    }
};
BuildingViewComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], BuildingViewComponent.prototype, "onChange", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BuildingViewComponent.prototype, "building", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('scene', { static: true })
], BuildingViewComponent.prototype, "sceneElement", void 0);
BuildingViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'building-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./building-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/building-view/building-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./building-view.component.scss */ "./src/app/components/building-view/building-view.component.scss")).default]
    })
], BuildingViewComponent);



/***/ }),

/***/ "./src/app/components/design-building/design-building.component.scss":
/*!***************************************************************************!*\
  !*** ./src/app/components/design-building/design-building.component.scss ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("select.form-control {\n  width: 200px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvY29tcG9uZW50cy9kZXNpZ24tYnVpbGRpbmcvZGVzaWduLWJ1aWxkaW5nLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9jb21wb25lbnRzL2Rlc2lnbi1idWlsZGluZy9kZXNpZ24tYnVpbGRpbmcuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0FDQ0YiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL2Rlc2lnbi1idWlsZGluZy9kZXNpZ24tYnVpbGRpbmcuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJzZWxlY3QuZm9ybS1jb250cm9sIHtcbiAgd2lkdGg6IDIwMHB4O1xufVxuIiwic2VsZWN0LmZvcm0tY29udHJvbCB7XG4gIHdpZHRoOiAyMDBweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/design-building/design-building.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/design-building/design-building.component.ts ***!
  \*************************************************************************/
/*! exports provided: DesignBuildingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DesignBuildingComponent", function() { return DesignBuildingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");



let DesignBuildingComponent = class DesignBuildingComponent {
    constructor(data) {
        this.roofTypes = [
            "Lapos tető",
            "Nyereg tető",
            "Félnyereg tető"
        ];
        this.show3d = true;
        let s = data.getDesignSettings().obj.subscribe((designSettings) => {
            this.formSettings = designSettings.buildingSettings;
            s.unsubscribe();
        });
    }
    get building() {
        return this.project.building;
    }
    ngOnInit() {
        if (this.project && !this.project.building.roof) {
            this.project.building.roof = this.roofTypes[1];
        }
    }
    sanitizeForm() {
        for (let field of ['width', 'length', 'height', 'extraWidth', 'weight']) {
            if (typeof (this.building[field]) !== 'number')
                this.building[field] = this.lastValues ? this.lastValues[field] : 0;
            if (this.building[field] < this.formSettings[field].min) {
                this.building[field] = this.formSettings[field].min;
            }
            else if (this.building[field] > this.formSettings[field].max) {
                this.building[field] = this.formSettings[field].max;
            }
        }
    }
    sizeChanged(building) {
        this.building.length = building.length;
        this.building.width = building.width;
        this.building.height = building.height;
        this.sanitizeForm();
    }
    checkpoint() {
        this.lastValues = Object.assign({}, this.building);
    }
    updateModelType() {
        this.show3d = false;
        setTimeout(() => {
            this.show3d = true;
        });
    }
};
DesignBuildingComponent.ctorParameters = () => [
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DesignBuildingComponent.prototype, "project", void 0);
DesignBuildingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-design-building',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./design-building.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/design-building/design-building.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./design-building.component.scss */ "./src/app/components/design-building/design-building.component.scss")).default]
    })
], DesignBuildingComponent);



/***/ }),

/***/ "./src/app/components/design-floating/design-floating.component.scss":
/*!***************************************************************************!*\
  !*** ./src/app/components/design-floating/design-floating.component.scss ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZGVzaWduLWZsb2F0aW5nL2Rlc2lnbi1mbG9hdGluZy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/components/design-floating/design-floating.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/design-floating/design-floating.component.ts ***!
  \*************************************************************************/
/*! exports provided: DesignFloatingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DesignFloatingComponent", function() { return DesignFloatingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");



let DesignFloatingComponent = class DesignFloatingComponent {
    constructor(data) {
        this.wallThicknessTypes = [
            '10 x 7',
            '10 x 8',
            '10 x 9',
            '10 x 10'
        ];
        this.types = [
            'EPS',
            'XPS'
        ];
        let s = data.getDesignSettings().obj.subscribe((designSettings) => {
            this.formSettings = designSettings.floatingSettings;
            this.typeMap = designSettings.foamSettings;
            s.unsubscribe();
        });
    }
    get floating() {
        return this.project.floating;
    }
    ngOnInit() {
    }
    sanitizeForm() {
        for (let field of ['width', 'length', 'height', 'aboveWater']) {
            if (typeof (this.floating[field]) !== 'number')
                this.floating[field] = this.lastValues ? this.lastValues[field] : 0;
            if (this.floating[field] < this.formSettings[field].min) {
                this.floating[field] = this.formSettings[field].min;
            }
            else if (this.floating[field] > this.formSettings[field].max) {
                this.floating[field] = this.formSettings[field].max;
            }
        }
    }
    sizeChanged(floating) {
        this.floating.length = floating.length;
        this.floating.width = floating.width;
        this.floating.height = floating.height;
        this.sanitizeForm();
    }
    checkpoint() {
        this.lastValues = Object.assign({}, this.floating);
    }
};
DesignFloatingComponent.ctorParameters = () => [
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DesignFloatingComponent.prototype, "project", void 0);
DesignFloatingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-design-floating',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./design-floating.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/design-floating/design-floating.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./design-floating.component.scss */ "./src/app/components/design-floating/design-floating.component.scss")).default]
    })
], DesignFloatingComponent);



/***/ }),

/***/ "./src/app/components/floating-view/floating-view.component.scss":
/*!***********************************************************************!*\
  !*** ./src/app/components/floating-view/floating-view.component.scss ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("canvas {\n  width: 100%;\n  height: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvY29tcG9uZW50cy9mbG9hdGluZy12aWV3L2Zsb2F0aW5nLXZpZXcuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvZmxvYXRpbmctdmlldy9mbG9hdGluZy12aWV3LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLFlBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZmxvYXRpbmctdmlldy9mbG9hdGluZy12aWV3LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiY2FudmFzIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbn1cbiIsImNhbnZhcyB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/floating-view/floating-view.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/floating-view/floating-view.component.ts ***!
  \*********************************************************************/
/*! exports provided: FloatingViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FloatingViewComponent", function() { return FloatingViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");
/* harmony import */ var _lib_floating__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/floating */ "./src/app/lib/floating.ts");
/* harmony import */ var _lib_floating_edge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../lib/floating-edge */ "./src/app/lib/floating-edge.ts");





let FloatingViewComponent = class FloatingViewComponent {
    constructor(zone) {
        this.zone = zone;
        this.onChange = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.isDragging = false;
        this.useFloatingEdge = false;
    }
    ngAfterViewInit() {
        this.renderScene();
    }
    ngOnDestroy() {
        if (this.scene) {
            this.scene.dispose();
            this.scene = null;
        }
    }
    renderScene() {
        if (this.scene) {
            this.scene.dispose();
            this.scene = null;
            this.isDragging = false;
        }
        if (!this.floating) {
            return;
        }
        const canvas = this.sceneElement.nativeElement;
        const engine = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Engine"](canvas);
        this.scene = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Scene"](engine);
        this.scene.clearColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Color4"](1.0, 1.0, 1.0);
        var hdrTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["HDRCubeTexture"]("/assets/textures/environment2.hdr", this.scene, 128);
        hdrTexture.gammaSpace = false;
        this.scene.environmentTexture = hdrTexture;
        //var camera = new ArcRotateCamera("Camera", 3.74, 1.3, 10, new Vector3(0, 0, -2), this.scene);
        var camera = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ArcRotateCamera"]("Camera", 3.74, 1.3, 10, new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, 0), this.scene);
        this.scene.activeCamera.attachControl(canvas);
        var floatingMiddle = new _lib_floating__WEBPACK_IMPORTED_MODULE_3__["Floating"](this.scene, this.floating, 'length2', true);
        floatingMiddle.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, -5);
        var floatingSide = new _lib_floating__WEBPACK_IMPORTED_MODULE_3__["Floating"](this.scene, this.floating, null, true);
        let floatingEdge;
        let floatingEdge2;
        if (this.useFloatingEdge) {
            floatingEdge = new _lib_floating_edge__WEBPACK_IMPORTED_MODULE_4__["FloatingEdge"](this.scene, floatingSide.controlMesh, 1);
            floatingEdge2 = new _lib_floating_edge__WEBPACK_IMPORTED_MODULE_4__["FloatingEdge"](this.scene, floatingSide.controlMesh, -1);
        }
        //--------------------------------------------------------------------------
        // resize building
        for (let floating of [floatingSide, floatingMiddle]) {
            let controls = [
                { field: 'controlMeshTop', change: 'y', factor: 1 },
                { field: 'controlMeshBottom', change: 'y', factor: -1 },
                { field: 'controlMeshLeft', change: 'x', factor: -1 },
                { field: 'controlMeshRight', change: 'x', factor: 1 },
            ];
            for (let control of controls) {
                let dragger = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["PointerDragBehavior"]();
                let draggedScale;
                dragger.onDragStartObservable.add((event) => {
                    this.isDragging = true;
                    floating[control.field].material.alpha = 0.1;
                });
                dragger.onDragObservable.add((event) => {
                    let delta;
                    switch (control.change) {
                        case 'x':
                            delta = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](event.delta.x * control.factor, 0, 0);
                            break;
                        case 'y':
                            delta = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, event.delta.y * control.factor, 0);
                            break;
                        case 'z':
                            delta = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, 0, event.delta.z * control.factor);
                            break;
                    }
                    floating.controlMesh.scaling = draggedScale = floating.controlMesh.scaling.add(delta);
                    this.zone.run(() => {
                        this.onChange.next({ floating: {
                                width: Math.round(floating.controlMesh.scaling.z * 2) / 2,
                                height: Math.round(floating.controlMesh.scaling.y * 10) / 10,
                                length: Math.round(floating.controlMesh.scaling.x * 2) / 2
                            } });
                    });
                });
                dragger.onDragEndObservable.add((event) => {
                    if (this.isDragging) {
                        this.zone.run(() => {
                            if (draggedScale) {
                                floating.controlMesh.scaling = draggedScale;
                                /*
                                this.floating[floating.lengthParam || 'length'] = Math.min(20, Math.round(floating.controlMesh.scaling.x * 2) / 2);
                                this.floating.height = Math.min(1.5, Math.max(0.8, Math.round(floating.controlMesh.scaling.y * 10) / 10));
                                this.floating.width = Math.round(floating.controlMesh.scaling.z * 2) / 2;
                                */
                                this.onChange.next({ floating: {
                                        width: Math.round(floating.controlMesh.scaling.z * 2) / 2,
                                        height: Math.round(floating.controlMesh.scaling.y * 10) / 10,
                                        [floating.lengthParam || 'length']: Math.round(floating.controlMesh.scaling.x * 2) / 2
                                    } });
                            }
                            this.isDragging = false;
                            floating[control.field].material.alpha = 0;
                        });
                    }
                });
                dragger.moveAttached = false;
                floating[control.field].isPickable = true;
                floating[control.field].actionManager = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ActionManager"](this.scene);
                floating[control.field].actionManager.registerAction(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ExecuteCodeAction"](_babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ActionManager"].OnPointerOverTrigger, (ev) => {
                    if (!this.isDragging) {
                        floating[control.field].material.alpha = 0.1;
                    }
                }));
                floating[control.field].actionManager.registerAction(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ExecuteCodeAction"](_babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["ActionManager"].OnPointerOutTrigger, (ev) => {
                    if (!this.isDragging) {
                        floating[control.field].material.alpha = 0.0;
                    }
                }));
                floating[control.field].addBehavior(dragger);
            }
        }
        //--------------------------------------------------------------------------
        engine.runRenderLoop(() => {
            if (!this.scene)
                return;
            if (this.useFloatingEdge && !floatingEdge.edge) {
                return;
            }
            if (camera.radius > 70)
                camera.radius = 70;
            if (camera.radius < 10)
                camera.radius = 10;
            if (this.floating.useLength2) {
                floatingMiddle.controlMesh.setEnabled(true);
                if (this.useFloatingEdge) {
                    floatingEdge.controlMesh.parent = floatingMiddle.controlMesh;
                    floatingEdge2.controlMesh.parent = floatingMiddle.controlMesh;
                }
                if (this.useFloatingEdge) {
                    floatingEdge.edge.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](1, 1, 0.3 * 2.5 / this.floating.length2);
                    floatingEdge2.edge.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](1, 1, 0.3 * 2.5 / this.floating.length2);
                }
                if (!this.isDragging) {
                    floatingMiddle.controlMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](this.floating.length2, this.floating.height, this.floating.width);
                }
            }
            else {
                if (this.useFloatingEdge) {
                    floatingEdge.controlMesh.parent = floatingSide.controlMesh;
                    floatingEdge2.controlMesh.parent = floatingSide.controlMesh;
                }
                floatingMiddle.controlMesh.setEnabled(false);
                if (this.useFloatingEdge) {
                    floatingEdge.edge.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](1, 1, 0.3 * 2.5 / this.floating.length);
                    floatingEdge2.edge.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](1, 1, 0.3 * 2.5 / this.floating.length);
                }
            }
            if (!this.isDragging) {
                floatingSide.controlMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](this.floating.length, this.floating.height, this.floating.width);
            }
            if (floatingSide.labels['width']) {
                floatingSide.labels['width'].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](0, -this.floating.height / 2 - 0.2, -this.floating.width / 2 - 0.2);
                floatingSide.labelTexts['width'].text = '' + this.floating.length + ' m';
                floatingSide.labels['height'].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](this.floating.length / 2 + 0.5, 0, -this.floating.width / 2 - 0.6);
                floatingSide.labelTexts['height'].text = '' + this.floating.height + ' m';
                floatingSide.labels['length'].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_2__["Vector3"](-this.floating.length / 2 - 0.2, -this.floating.height / 2 - 0.2, 0);
                floatingSide.labelTexts['length'].text = '' + this.floating.width + ' m';
            }
            floatingSide.updateFoamMaterial(this.floating.type);
            floatingSide.resize(this.floating);
            floatingMiddle.updateFoamMaterial(this.floating.type);
            floatingMiddle.resize(this.floating);
            this.scene.render();
        });
        window.addEventListener("resize", function () {
            try {
                engine.resize();
            }
            catch (e) { }
        });
    }
};
FloatingViewComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], FloatingViewComponent.prototype, "onChange", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FloatingViewComponent.prototype, "floating", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('scene', { static: true })
], FloatingViewComponent.prototype, "sceneElement", void 0);
FloatingViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'floating-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./floating-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/floating-view/floating-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./floating-view.component.scss */ "./src/app/components/floating-view/floating-view.component.scss")).default]
    })
], FloatingViewComponent);



/***/ }),

/***/ "./src/app/components/preview/preview.component.scss":
/*!***********************************************************!*\
  !*** ./src/app/components/preview/preview.component.scss ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcHJldmlldy9wcmV2aWV3LmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/preview/preview.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/preview/preview.component.ts ***!
  \*********************************************************/
/*! exports provided: PreviewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviewComponent", function() { return PreviewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let PreviewComponent = class PreviewComponent {
    constructor() { }
    get floating() {
        return this.project.floating;
    }
    get building() {
        return this.project.building;
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PreviewComponent.prototype, "project", void 0);
PreviewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-preview',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./preview.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/preview/preview.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./preview.component.scss */ "./src/app/components/preview/preview.component.scss")).default]
    })
], PreviewComponent);



/***/ }),

/***/ "./src/app/components/result-container/result-container.component.scss":
/*!*****************************************************************************!*\
  !*** ./src/app/components/result-container/result-container.component.scss ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#preview {\n  max-height: calc(100vh - 21rem);\n  min-height: calc(100vh - 21rem);\n  background: #fff;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n#preview-inner {\n  width: 100%;\n  max-height: calc(100vh - 21rem);\n  min-height: calc(100vh - 21rem);\n  margin: 0 auto;\n  text-align: left;\n}\n\n#docview {\n  width: 100%;\n  max-height: calc(100vh - 21rem);\n  min-height: calc(100vh - 21rem);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvY29tcG9uZW50cy9yZXN1bHQtY29udGFpbmVyL3Jlc3VsdC1jb250YWluZXIuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvcmVzdWx0LWNvbnRhaW5lci9yZXN1bHQtY29udGFpbmVyLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsK0JBQUE7RUFDQSwrQkFBQTtFQUNBLGdCQUFBO0VBQ0EsdUNBQUE7RUFDQSxrQkFBQTtBQ0NGOztBREVBO0VBQ0UsV0FBQTtFQUNBLCtCQUFBO0VBQ0EsK0JBQUE7RUFDQSxjQUFBO0VBQ0EsZ0JBQUE7QUNDRjs7QURFQTtFQUNFLFdBQUE7RUFDQSwrQkFBQTtFQUNBLCtCQUFBO0FDQ0YiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL3Jlc3VsdC1jb250YWluZXIvcmVzdWx0LWNvbnRhaW5lci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIiNwcmV2aWV3IHtcbiAgbWF4LWhlaWdodDogY2FsYygxMDB2aCAtIDIxcmVtKTtcbiAgbWluLWhlaWdodDogY2FsYygxMDB2aCAtIDIxcmVtKTtcbiAgYmFja2dyb3VuZDogI2ZmZjtcbiAgYm94LXNoYWRvdzogMCAwIDIwcHggcmdiYSgwLDAsMCwwLjIpO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbiNwcmV2aWV3LWlubmVyIHtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC1oZWlnaHQ6IGNhbGMoMTAwdmggLSAyMXJlbSk7XG4gIG1pbi1oZWlnaHQ6IGNhbGMoMTAwdmggLSAyMXJlbSk7XG4gIG1hcmdpbjogMCBhdXRvO1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xufVxuXG4jZG9jdmlldyB7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoIC0gMjFyZW0pO1xuICBtaW4taGVpZ2h0OiBjYWxjKDEwMHZoIC0gMjFyZW0pO1xufVxuIiwiI3ByZXZpZXcge1xuICBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoIC0gMjFyZW0pO1xuICBtaW4taGVpZ2h0OiBjYWxjKDEwMHZoIC0gMjFyZW0pO1xuICBiYWNrZ3JvdW5kOiAjZmZmO1xuICBib3gtc2hhZG93OiAwIDAgMjBweCByZ2JhKDAsIDAsIDAsIDAuMik7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuI3ByZXZpZXctaW5uZXIge1xuICB3aWR0aDogMTAwJTtcbiAgbWF4LWhlaWdodDogY2FsYygxMDB2aCAtIDIxcmVtKTtcbiAgbWluLWhlaWdodDogY2FsYygxMDB2aCAtIDIxcmVtKTtcbiAgbWFyZ2luOiAwIGF1dG87XG4gIHRleHQtYWxpZ246IGxlZnQ7XG59XG5cbiNkb2N2aWV3IHtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC1oZWlnaHQ6IGNhbGMoMTAwdmggLSAyMXJlbSk7XG4gIG1pbi1oZWlnaHQ6IGNhbGMoMTAwdmggLSAyMXJlbSk7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/result-container/result-container.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/components/result-container/result-container.component.ts ***!
  \***************************************************************************/
/*! exports provided: ResultContainerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResultContainerComponent", function() { return ResultContainerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var print_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! print-js */ "./node_modules/print-js/dist/print.js");
/* harmony import */ var print_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(print_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");





let ResultContainerComponent = class ResultContainerComponent {
    constructor(http, data) {
        this.http = http;
        this.data = data;
        this.loading = true;
    }
    ngAfterViewInit() {
        let s = this.data.getDesignSettings().obj.subscribe((designSettings) => {
            s.unsubscribe();
            let settings = {
                solarPower: designSettings.solarPower,
                mksz_percent: designSettings.mksz_percent,
                densityMap: {},
                ps_price_factor: {}
            };
            for (let foamType in designSettings.foamSettings) {
                settings.densityMap[foamType] = designSettings.foamSettings[foamType].density;
                settings.ps_price_factor[foamType] = designSettings.foamSettings[foamType].price;
            }
            let domain = 'https://pontonterv.complexolution.com';
            this.http.post(domain + '/pdf.php', {
                project: this.project,
                settings: settings
            }, { responseType: 'text' }).subscribe(data => {
                let docx = domain + '/eredmenyek/' + data;
                let pdf = docx.replace(/docx$/, 'pdf');
                console.log("DOCX", docx);
                console.log("PDF", pdf);
                //jQuery('#docview').attr('src', pdf + '?_=' + Date.now());
                this.pdfUrl = pdf + '?_=' + Date.now();
                this.setIframeContent();
                this.loading = false;
            });
        });
    }
    setIframeContent(print) {
        if (print) {
            print_js__WEBPACK_IMPORTED_MODULE_3__({
                printable: this.pdfUrl,
                type: 'pdf',
                showModal: true,
                modalMessage: 'PDF betöltése...'
            });
        }
        else {
            jQuery('#docview').contents().find('body').html('<style>html,body,iframe{padding:0;margin:0;width:100%;height:100%;}</style><iframe frameborder="0" src="' + this.pdfUrl + '"></iframe>');
        }
    }
    print() {
        this.setIframeContent(true);
    }
};
ResultContainerComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ResultContainerComponent.prototype, "project", void 0);
ResultContainerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-result-container',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./result-container.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/result-container/result-container.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./result-container.component.scss */ "./src/app/components/result-container/result-container.component.scss")).default]
    })
], ResultContainerComponent);



/***/ }),

/***/ "./src/app/dialogs/about-dialog/about-dialog.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/dialogs/about-dialog/about-dialog.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2RpYWxvZ3MvYWJvdXQtZGlhbG9nL2Fib3V0LWRpYWxvZy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/dialogs/about-dialog/about-dialog.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/dialogs/about-dialog/about-dialog.component.ts ***!
  \****************************************************************/
/*! exports provided: AboutDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AboutDialogComponent", function() { return AboutDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../environments/environment */ "./src/environments/environment.ts");




let AboutDialogComponent = class AboutDialogComponent {
    constructor(modal) {
        this.modal = modal;
        this.version = _environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].version;
    }
    ngOnInit() {
    }
};
AboutDialogComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] }
];
AboutDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-about-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./about-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/about-dialog/about-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./about-dialog.component.scss */ "./src/app/dialogs/about-dialog/about-dialog.component.scss")).default]
    })
], AboutDialogComponent);



/***/ }),

/***/ "./src/app/dialogs/confirm-dialog/confirm-dialog.component.scss":
/*!**********************************************************************!*\
  !*** ./src/app/dialogs/confirm-dialog/confirm-dialog.component.scss ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2RpYWxvZ3MvY29uZmlybS1kaWFsb2cvY29uZmlybS1kaWFsb2cuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/dialogs/confirm-dialog/confirm-dialog.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/dialogs/confirm-dialog/confirm-dialog.component.ts ***!
  \********************************************************************/
/*! exports provided: ConfirmDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfirmDialogComponent", function() { return ConfirmDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");



let ConfirmDialogComponent = class ConfirmDialogComponent {
    constructor(modal) {
        this.modal = modal;
        this.params = {};
    }
    ngOnInit() {
        setTimeout(() => {
            if (this.params) {
                for (var key in this.params) {
                    this[key] = this.params[key];
                }
            }
        }, 100);
    }
    ok() {
        this.modal.close(this);
    }
};
ConfirmDialogComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] }
];
ConfirmDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-confirm-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./confirm-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/confirm-dialog/confirm-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./confirm-dialog.component.scss */ "./src/app/dialogs/confirm-dialog/confirm-dialog.component.scss")).default]
    })
], ConfirmDialogComponent);



/***/ }),

/***/ "./src/app/dialogs/project-name-dialog/project-name-dialog.component.scss":
/*!********************************************************************************!*\
  !*** ./src/app/dialogs/project-name-dialog/project-name-dialog.component.scss ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2RpYWxvZ3MvcHJvamVjdC1uYW1lLWRpYWxvZy9wcm9qZWN0LW5hbWUtZGlhbG9nLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/dialogs/project-name-dialog/project-name-dialog.component.ts":
/*!******************************************************************************!*\
  !*** ./src/app/dialogs/project-name-dialog/project-name-dialog.component.ts ***!
  \******************************************************************************/
/*! exports provided: ProjectNameDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectNameDialogComponent", function() { return ProjectNameDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");



let ProjectNameDialogComponent = class ProjectNameDialogComponent {
    constructor(modal) {
        this.modal = modal;
        this.newProjectName = '';
    }
    ngOnInit() {
    }
};
ProjectNameDialogComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] }
];
ProjectNameDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-project-name-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./project-name-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/project-name-dialog/project-name-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./project-name-dialog.component.scss */ "./src/app/dialogs/project-name-dialog/project-name-dialog.component.scss")).default]
    })
], ProjectNameDialogComponent);



/***/ }),

/***/ "./src/app/layouts/app-layout/app-layout.component.scss":
/*!**************************************************************!*\
  !*** ./src/app/layouts/app-layout/app-layout.component.scss ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".navbar .btn-primary {\n  border: 1px solid #fff;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvbGF5b3V0cy9hcHAtbGF5b3V0L2FwcC1sYXlvdXQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2xheW91dHMvYXBwLWxheW91dC9hcHAtbGF5b3V0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usc0JBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL2xheW91dHMvYXBwLWxheW91dC9hcHAtbGF5b3V0LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm5hdmJhciAuYnRuLXByaW1hcnkge1xuICBib3JkZXI6IDFweCBzb2xpZCAjZmZmO1xufVxuIiwiLm5hdmJhciAuYnRuLXByaW1hcnkge1xuICBib3JkZXI6IDFweCBzb2xpZCAjZmZmO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/layouts/app-layout/app-layout.component.ts":
/*!************************************************************!*\
  !*** ./src/app/layouts/app-layout/app-layout.component.ts ***!
  \************************************************************/
/*! exports provided: AppLayoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppLayoutComponent", function() { return AppLayoutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");





let AppLayoutComponent = class AppLayoutComponent {
    constructor(afAuth, router, dataService) {
        this.afAuth = afAuth;
        this.router = router;
        this.dataService = dataService;
    }
    ngOnInit() {
    }
    logout() {
        this.afAuth.auth.signOut().then(() => {
            this.router.navigate(['/auth/login']);
        });
    }
};
AppLayoutComponent.ctorParameters = () => [
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] }
];
AppLayoutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-app-layout',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app-layout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/layouts/app-layout/app-layout.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app-layout.component.scss */ "./src/app/layouts/app-layout/app-layout.component.scss")).default]
    })
], AppLayoutComponent);



/***/ }),

/***/ "./src/app/layouts/auth-layout/auth-layout.component.scss":
/*!****************************************************************!*\
  !*** ./src/app/layouts/auth-layout/auth-layout.component.scss ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xheW91dHMvYXV0aC1sYXlvdXQvYXV0aC1sYXlvdXQuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/layouts/auth-layout/auth-layout.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/layouts/auth-layout/auth-layout.component.ts ***!
  \**************************************************************/
/*! exports provided: AuthLayoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthLayoutComponent", function() { return AuthLayoutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AuthLayoutComponent = class AuthLayoutComponent {
    constructor() { }
    ngOnInit() {
    }
};
AuthLayoutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-auth-layout',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./auth-layout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/layouts/auth-layout/auth-layout.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./auth-layout.component.scss */ "./src/app/layouts/auth-layout/auth-layout.component.scss")).default]
    })
], AuthLayoutComponent);



/***/ }),

/***/ "./src/app/lib/building.ts":
/*!*********************************!*\
  !*** ./src/app/lib/building.ts ***!
  \*********************************/
/*! exports provided: Building */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Building", function() { return Building; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");
/* harmony import */ var _babylonjs_materials__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babylonjs/materials */ "./node_modules/@babylonjs/materials/index.js");
/* harmony import */ var _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babylonjs/gui */ "./node_modules/@babylonjs/gui/index.js");




class Building {
    constructor(scene, buildingSize, showRuler) {
        this.labels = {};
        this.labelTexts = {};
        //--------------------------------------------------------------------------
        let woodMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("wood", scene);
        woodMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.75, 0.75, 0.8);
        woodMaterial.bumpTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/wood1/Wood_plank_007_NORM.jpg', scene);
        woodMaterial.metallic = 0.1;
        woodMaterial.roughness = 0.8;
        //--------------------------------------------------------------------------
        let metalMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("metal", scene);
        metalMaterial.albedoTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/metal3/Metal_Weave_003_basecolor.jpg', scene);
        metalMaterial.metallicTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/metal3/Metal_Weave_003_metallic.jpg', scene);
        metalMaterial.bumpTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/metal3/Metal_Weave_003_normal.jpg', scene);
        metalMaterial.ambientTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/metal3/Metal_Weave_003_ambientOcclusion.jpg', scene);
        metalMaterial.opacityTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/metal3/Metal_Weave_003_opacity.jpg', scene);
        //--------------------------------------------------------------------------
        let concreteMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("concrete", scene);
        concreteMaterial.albedoTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/concrete1/Concrete_Wall_001_Base_Color.jpg', scene);
        concreteMaterial.metallicTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/concrete1/Concrete_Wall_001_Roughness.jpg', scene);
        concreteMaterial.bumpTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/concrete1/Concrete_Wall_001_Normal.jpg', scene);
        concreteMaterial.ambientTexture = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Texture"]('/assets/textures/concrete1/Concrete_Wall_001_Ambient_Occlusion.jpg', scene);
        //--------------------------------------------------------------------------
        let roofMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("roof", scene);
        roofMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.5, 0.0, 0.0);
        roofMaterial.metallic = 0.0;
        roofMaterial.roughness = 0.9;
        this.roofMaterial = roofMaterial;
        //--------------------------------------------------------------------------
        let solarMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("solar", scene);
        solarMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0, 0, 0);
        solarMaterial.metallic = 0.5;
        solarMaterial.roughness = 0.3;
        this.solarMaterial = solarMaterial;
        //--------------------------------------------------------------------------
        var glass = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("glass", scene);
        glass.directIntensity = 1.0;
        glass.environmentIntensity = 0.1;
        glass.cameraExposure = 0.66;
        glass.cameraContrast = 1.66;
        glass.microSurface = 1;
        glass.reflectivityColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](1.0, 1.0, 1.0);
        glass.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.95, 0.95, 0.95);
        glass.alpha = 0.8;
        //--------------------------------------------------------------------------
        this.controlMesh = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("building", { height: 1, width: 1, depth: 1 }, scene);
        this.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        this.controlMeshTop = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshTop", { height: 0.1, width: 1, depth: 1 }, scene);
        this.controlMeshTop.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0.5, 0);
        this.controlMeshTop.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat1", scene);
        this.controlMeshTop.material.alpha = 0.;
        this.controlMeshTop.parent = this.controlMesh;
        this.controlMeshBottom = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshBottom", { height: 0.1, width: 1, depth: 1 }, scene);
        this.controlMeshBottom.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -0.5, 0);
        this.controlMeshBottom.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat2", scene);
        this.controlMeshBottom.material.alpha = 0.;
        this.controlMeshBottom.parent = this.controlMesh;
        this.controlMeshLeft = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshLeft", { height: 0, width: 0.1, depth: 1 }, scene);
        this.controlMeshLeft.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-0.5, 0, 0);
        this.controlMeshLeft.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat3", scene);
        this.controlMeshLeft.material.alpha = 0.;
        this.controlMeshLeft.parent = this.controlMesh;
        this.controlMeshRight = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshRight", { height: 0, width: 0.1, depth: 1 }, scene);
        this.controlMeshRight.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0.5, 0, 0);
        this.controlMeshRight.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat4", scene);
        this.controlMeshRight.material.alpha = 0.;
        this.controlMeshRight.parent = this.controlMesh;
        this.controlMeshFront = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshFront", { height: 0, width: 0, depth: 0.1 }, scene);
        this.controlMeshFront.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, -0.5);
        this.controlMeshFront.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat5", scene);
        this.controlMeshFront.material.alpha = 0.;
        this.controlMeshFront.parent = this.controlMesh;
        this.controlMeshBack = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshBack", { height: 0, width: 0, depth: 0.1 }, scene);
        this.controlMeshBack.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0.5);
        this.controlMeshBack.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat6", scene);
        this.controlMeshBack.material.alpha = 0.;
        this.controlMeshBack.parent = this.controlMesh;
        this.buildingParentMesh = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("buildingParent", { height: 0.4, width: 16, depth: 16 }, scene);
        this.buildingParentMesh.setPivotPoint(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -0.2, 0));
        this.buildingParentMesh.material = concreteMaterial;
        if (buildingSize) {
            this.controlMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](buildingSize.length, buildingSize.height, buildingSize.width);
        }
        this.controlMesh.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat0", scene);
        this.controlMesh.material.alpha = 0;
        this.centerOfMass = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateSphere("com", { diameter: 1, diameterX: 1 }, scene);
        let red = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("red", scene);
        red.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](1, 0, 0);
        red.metallic = 0;
        red.roughness = 1;
        this.centerOfMass.material = red;
        let centerOfMassLabel = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateSphere("centerOfMass", { diameter: 1.001, diameterX: 1.001 }, scene);
        //centerOfMassLabel.position = new Vector3(0, 0, 0);
        centerOfMassLabel.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](Math.PI, -Math.PI / 4, 0);
        let centerOfMassLabelGui = _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["AdvancedDynamicTexture"].CreateForMesh(centerOfMassLabel, 1024, 1024);
        let centerOfMassLabelText = new _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["TextBlock"]("centerLabel", "Tömeg-\nközéppont");
        centerOfMassLabelText.fontSize = 80;
        centerOfMassLabelText.color = '#fff';
        centerOfMassLabelText.shadowBlur = 5;
        centerOfMassLabelGui.addControl(centerOfMassLabelText);
        centerOfMassLabel.setParent(this.centerOfMass);
        this.centerOfMass.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -buildingSize.height / 6, 0);
        this.center = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateSphere("com", { diameter: 1, diameterX: 1 }, scene);
        this.center.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        let blue = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("blue", scene);
        blue.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0, 0, 1);
        blue.metallic = 0;
        blue.roughness = 1;
        this.center.material = blue;
        let centerLabel = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateSphere("metacenterum", { diameter: 1.001, diameterX: 1.001 }, scene);
        centerLabel.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        centerLabel.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](Math.PI, -Math.PI / 4, 0);
        let centerLabelGui = _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["AdvancedDynamicTexture"].CreateForMesh(centerLabel, 1024, 1024);
        let centerLabelText = new _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["TextBlock"]("centerLabel", "Meta-\ncentrum");
        centerLabelText.fontSize = 80;
        centerLabelText.color = '#fff';
        centerLabelText.shadowBlur = 5;
        centerLabelGui.addControl(centerLabelText);
        centerLabel.setParent(this.center);
        if (showRuler) {
            let gm = new _babylonjs_materials__WEBPACK_IMPORTED_MODULE_2__["GridMaterial"]("g1", scene);
            gm.opacity = 0.99; //0.2;
            gm.gridRatio = 0.1;
            gm.majorUnitFrequency = 5;
            gm.minorUnitVisibility = 0.1;
            gm.backFaceCulling = false;
            for (let f of ['length', 'height', 'width']) {
                this.labels[f] = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreatePlane("ruler", { width: 5, height: 5 }, scene);
                this.labels[f].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
                var gui = _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["AdvancedDynamicTexture"].CreateForMesh(this.labels[f], 1024, 1024);
                this.labelTexts[f] = new _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["TextBlock"]("b_" + f, "0.0");
                this.labelTexts[f].fontSize = 200;
                gui.addControl(this.labelTexts[f]);
            }
            this.labels.length.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            this.labels.height.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            this.rulers = [];
            for (let i = 0; i < 3; i++) {
                let grid = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreatePlane("p1", { width: 100, height: 0.19 }, scene);
                grid.material = gm;
                this.rulers.push(grid);
            }
            this.rulers[1].rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, Math.PI / 2);
            this.rulers[2].rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
        }
        let modelName;
        let heightFactor;
        switch (buildingSize.roof) {
            case "Lapos tető":
                modelName = 'building1';
                heightFactor = 0.205;
                break;
            case "Félnyereg tető":
                modelName = 'building3';
                heightFactor = 0.125;
                break;
            default:
                modelName = "building2";
                heightFactor = 1 / 8;
        }
        _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["SceneLoader"].LoadAssetContainer("/assets/models/", modelName + ".obj", scene, (container) => {
            for (let mesh of container.meshes) {
                mesh.parent = this.buildingParentMesh;
                mesh.createNormals(true);
                if (/roof_/.test(mesh.name)) {
                    //mesh.material = this.getRoofMaterial(buildingSize);
                    mesh.material = roofMaterial;
                    this.roof = mesh;
                }
                else if (/roofwall/.test(mesh.name)) {
                    mesh.material = woodMaterial;
                }
                else {
                    switch (mesh.material.name) {
                        case 'wood':
                        case 'white_st':
                        case 'standart_metal':
                            mesh.material = woodMaterial;
                            break;
                        case 'blue':
                            mesh.material = roofMaterial;
                            break;
                        case 'green':
                        case 'black_st':
                        case 'yellow':
                            mesh.material = concreteMaterial;
                            break;
                        case 'clear_window':
                            mesh.material = glass;
                            break;
                        default:
                            console.log(mesh.material.name);
                    }
                }
                scene.addMesh(mesh);
            }
            this.buildingParentMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](1 / 16, heightFactor, 1 / 16);
            this.buildingParentMesh.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            this.buildingParentMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -0.3, 0);
            this.buildingParentMesh.parent = this.controlMesh;
        });
    }
    getRoofMaterial(building) {
        return building && building.solar ? this.solarMaterial : this.roofMaterial;
    }
    resize(floatingSize, relativePosition) {
        if (!relativePosition) {
            relativePosition = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        }
        if (this.rulers) {
            this.rulers[0].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -floatingSize.height / 2, -floatingSize.width / 2 - 0.1));
            this.rulers[1].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2, 0, -floatingSize.width / 2 - 0.1));
            this.rulers[2].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 2, -floatingSize.height / 2, floatingSize.width / 2 - 0.1));
        }
        this.centerOfMass.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -floatingSize.height / 4, 0));
        this.center.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0));
        if (this.roof) {
            this.roof.material = this.getRoofMaterial(floatingSize);
        }
    }
}


/***/ }),

/***/ "./src/app/lib/floating-edge.ts":
/*!**************************************!*\
  !*** ./src/app/lib/floating-edge.ts ***!
  \**************************************/
/*! exports provided: FloatingEdge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FloatingEdge", function() { return FloatingEdge; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");


class FloatingEdge {
    constructor(scene, parentMesh, side) {
        this.meshes = [];
        /*
        let concreteMaterial = new PBRMaterial("concrete", scene);
        concreteMaterial.albedoTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Base_Color.jpg', scene);
        concreteMaterial.metallicTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Roughness.jpg', scene);
        concreteMaterial.bumpTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Normal.jpg', scene);
        concreteMaterial.ambientTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Ambient_Occlusion.jpg', scene);
        */
        let concreteMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("concrete", scene);
        concreteMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.5, 0.5, 0.5);
        concreteMaterial.metallic = 0;
        concreteMaterial.roughness = 0.9;
        this.controlMesh = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("floating", { height: 1, width: 1, depth: 1 }, scene);
        this.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        this.controlMesh.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat0", scene);
        this.controlMesh.material.alpha = 0;
        this.floatingParentMesh = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("floatingParent", { height: 2, width: 2, depth: 2 }, scene);
        this.floatingParentMesh.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMatX", scene);
        this.floatingParentMesh.material.alpha = 0;
        _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["SceneLoader"].LoadAssetContainer("/assets/models/", "floating-edge.obj", scene, (floatingEdgeContainer) => {
            try {
                for (let edge1 of floatingEdgeContainer.meshes) {
                    //edge1.scaling = new Vector3(0.5, 0.5, 0.5);
                    edge1.setPivotMatrix(_babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Matrix"].Translation(0, 0, 1));
                    edge1.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](1 * side, 0, 1);
                    edge1.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](1, 1, 0.3);
                    edge1.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
                    if (side === -1) {
                        edge1.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -Math.PI / 2, 0);
                    }
                    edge1.parent = this.floatingParentMesh;
                    edge1.material = concreteMaterial;
                    edge1.createNormals(true);
                    scene.addMesh(edge1);
                    this.meshes.push(edge1);
                    this.edge = edge1;
                    break;
                }
                this.floatingParentMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0.5, 0.5, 0.5);
                this.floatingParentMesh.parent = this.controlMesh;
            }
            catch (e) {
                console.error(e);
            }
        });
        this.controlMesh.parent = parentMesh;
    }
}


/***/ }),

/***/ "./src/app/lib/floating.ts":
/*!*********************************!*\
  !*** ./src/app/lib/floating.ts ***!
  \*********************************/
/*! exports provided: Floating */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Floating", function() { return Floating; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babylonjs/core */ "./node_modules/@babylonjs/core/index.js");
/* harmony import */ var _babylonjs_materials__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babylonjs/materials */ "./node_modules/@babylonjs/materials/index.js");
/* harmony import */ var _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babylonjs/gui */ "./node_modules/@babylonjs/gui/index.js");




class Floating {
    constructor(scene, floatingSize, lengthParam, showRuler) {
        this.floatingSize = floatingSize;
        this.lengthParam = lengthParam;
        this.outerWallWidth = 0.1;
        this.nutSize = 0.05;
        this.nutHeight = 0.1;
        this.hookSize = 0.05;
        this.meshes = [];
        this.labels = {};
        this.labelTexts = {};
        this.walls = {};
        this.separatorWalls = [];
        let concreteMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("concrete", scene);
        concreteMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.5, 0.5, 0.5);
        concreteMaterial.metallic = 0;
        concreteMaterial.roughness = 0.9;
        /*
        concreteMaterial.albedoTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Base_Color.jpg', scene);
        concreteMaterial.metallicTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Roughness.jpg', scene);
        concreteMaterial.bumpTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Normal.jpg', scene);
        concreteMaterial.ambientTexture = new Texture('/assets/textures/concrete1/Concrete_Wall_001_Ambient_Occlusion.jpg', scene);
        */
        let foamMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("concrete", scene);
        this.foamMaterial = foamMaterial;
        this.updateFoamMaterial();
        foamMaterial.metallic = 0;
        foamMaterial.roughness = 0.9;
        let holeMaterial = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["PBRMaterial"]("hole", scene);
        holeMaterial.metallic = 1;
        holeMaterial.roughness = 0;
        //holeMaterial.emissiveColor = new Color3(1,1,1);
        this.controlMesh = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("floating", { height: 1, width: 1, depth: 1 }, scene);
        this.controlMesh.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        this.controlMeshTop = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshTop", { height: 0.1, width: 1, depth: 1 }, scene);
        this.controlMeshTop.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0.6, 0);
        this.controlMeshTop.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat1", scene);
        this.controlMeshTop.material.alpha = 0.;
        this.controlMeshTop.parent = this.controlMesh;
        this.controlMeshBottom = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshBottom", { height: 0.1, width: 1, depth: 1 }, scene);
        this.controlMeshBottom.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -0.6, 0);
        this.controlMeshBottom.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat2", scene);
        this.controlMeshBottom.material.alpha = 0.;
        this.controlMeshBottom.parent = this.controlMesh;
        this.controlMeshLeft = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshLeft", { height: 1.5, width: 0.1, depth: 1.5 }, scene);
        this.controlMeshLeft.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-0.6, 0, 0);
        this.controlMeshLeft.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat3", scene);
        this.controlMeshLeft.material.alpha = 0.;
        this.controlMeshLeft.parent = this.controlMesh;
        this.controlMeshRight = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshRight", { height: 1.5, width: 0.1, depth: 1.5 }, scene);
        this.controlMeshRight.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0.6, 0, 0);
        this.controlMeshRight.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat4", scene);
        this.controlMeshRight.material.alpha = 0.;
        this.controlMeshRight.parent = this.controlMesh;
        this.controlMeshFront = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshFront", { height: 0, width: 0, depth: 0.1 }, scene);
        this.controlMeshFront.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, -0.6);
        this.controlMeshFront.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat5", scene);
        this.controlMeshFront.material.alpha = 0.;
        this.controlMeshFront.parent = this.controlMesh;
        this.controlMeshBack = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("controlMeshBack", { height: 0, width: 0, depth: 0.1 }, scene);
        this.controlMeshBack.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0.6);
        this.controlMeshBack.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat6", scene);
        this.controlMeshBack.material.alpha = 0.;
        this.controlMeshBack.parent = this.controlMesh;
        if (floatingSize) {
            this.controlMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](lengthParam ? floatingSize[lengthParam] : floatingSize.length, floatingSize.height, floatingSize.width);
        }
        this.controlMesh.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat0", scene);
        this.controlMesh.material.alpha = 0;
        this.floatingParentMesh = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("floatingParent", { height: 2, width: 2, depth: 2 }, scene);
        this.floatingParentMesh.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMatX", scene);
        this.floatingParentMesh.material.alpha = 0;
        if (showRuler) {
            let gm = new _babylonjs_materials__WEBPACK_IMPORTED_MODULE_2__["GridMaterial"]("g1", scene);
            gm.opacity = 0.99; //0.2;
            gm.gridRatio = 0.1;
            gm.majorUnitFrequency = 5;
            gm.minorUnitVisibility = 0.1;
            gm.backFaceCulling = false;
            this.rulers = [];
            for (let i = 0; i < 3; i++) {
                let grid = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreatePlane("p1", { width: 100, height: 0.1 }, scene);
                grid.material = gm;
                this.rulers.push(grid);
            }
            this.rulers[1].rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, Math.PI / 2);
            this.rulers[2].rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            for (let f of ['length', 'height', 'width']) {
                this.labels[f] = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreatePlane("ruler", { width: 1, height: 1 }, scene); // MeshBuilder.CreateBox("uiParent", {height: 1, width: 1, depth: 1}, scene);
                this.labels[f].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
                var gui = _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["AdvancedDynamicTexture"].CreateForMesh(this.labels[f], 1024, 1024);
                this.labelTexts[f] = new _babylonjs_gui__WEBPACK_IMPORTED_MODULE_3__["TextBlock"]("b_" + f, "0.0");
                this.labelTexts[f].fontSize = 200;
                gui.addControl(this.labelTexts[f]);
            }
            this.labels.length.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            this.labels.height.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            this.nuts = [];
            for (let i = 0; i < 8; i++) {
                let nut = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox('nut' + i, { width: 1, height: this.nutHeight, depth: 1 }, scene);
                nut.material = i < 4 ? concreteMaterial : holeMaterial;
                this.nuts.push(nut);
            }
            _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["SceneLoader"].LoadAssetContainer("/assets/models/", "hook.obj", scene, (container) => {
                this.hooks = [];
                this.hooksBottom = [];
                let hookParent = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("b1", { width: 1, height: 1, depth: 1 }, scene);
                hookParent.material = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["StandardMaterial"]("transparentMat5", scene);
                hookParent.material.alpha = 0;
                this.hookSize = 0.05;
                hookParent.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](this.hookSize, this.hookSize, this.hookSize);
                for (let mesh of container.meshes) {
                    if (mesh.name !== 'Telfer') {
                        mesh.material = concreteMaterial;
                        mesh.parent = hookParent;
                        scene.addMesh(mesh);
                    }
                    //this.meshes.push(mesh);
                }
                hookParent.position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
                this.hooks.push(hookParent);
                for (let hi = 1; hi <= 7; hi++) {
                    this.hooks.push(hookParent.clone("hook" + hi));
                }
                for (let hi = 0; hi <= 7; hi++) {
                    this.hooksBottom.push(hookParent.clone("hookBottom" + hi));
                    this.hooksBottom[hi].rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](Math.PI, 0, 0);
                }
            });
        }
        let foam = this.foam = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox('foam', { width: 1, height: 1, depth: 1 }, scene);
        foam.material = foamMaterial;
        //foam.parent = this.floatingParentMesh;
        for (let w of ['top', 'front', 'back', 'left', 'right']) {
            this.walls[w] = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("wall_" + w, { width: 1, height: 1, depth: this.outerWallWidth }, scene);
            this.walls[w].position = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
            this.walls[w].material = concreteMaterial;
        }
        this.walls.top.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](Math.PI / 2, 0, 0);
        this.walls.front.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
        this.walls.back.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -Math.PI / 2, 0);
        let sw = 0;
        for (sw = 0; sw < 2; sw++) {
            let w2 = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].CreateBox("swall_" + sw, { width: 1, height: 1, depth: this.outerWallWidth }, scene);
            w2.rotation = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, Math.PI / 2, 0);
            w2.material = concreteMaterial;
            this.separatorWalls.push(w2);
        }
        /*SceneLoader.LoadAssetContainer("/assets/models/", "floating.obj", scene, (container)=>{
          for (let mesh of container.meshes){
            mesh.parent = this.floatingParentMesh;
            mesh.createNormals(true);
            switch (mesh.name) {
              case 'ConcreteBox_Cube':
                mesh.material = concreteMaterial;
                break;
              case 'FillMaterial_Cube.001':
                mesh.material = foamMaterial;
                break;
              default:
                console.log(mesh.name);
            }
            scene.addMesh(mesh);
            this.meshes.push(mesh);
          }*/
        this.floatingParentMesh.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0.5, 0.5, 0.5);
        this.floatingParentMesh.parent = this.controlMesh;
        //})
        this.resize(floatingSize);
        if (this.nuts) {
            let root = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["TransformNode"]("");
            this.walls.right.parent = root;
            this.nuts[4].parent = root;
            this.nuts[5].parent = root;
            let hole = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["CSG"].FromMesh(this.nuts[4]);
            let hole2 = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["CSG"].FromMesh(this.nuts[5]);
            let holex = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["CSG"].FromMesh(this.nuts[6]);
            let holex2 = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["CSG"].FromMesh(this.nuts[7]);
            let wall = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["CSG"].FromMesh(this.walls.right);
            let newHolePlate = wall.subtract(hole).subtract(hole2).subtract(holex).subtract(holex2);
            let newMeshHolePlate = newHolePlate.toMesh("rwn1", concreteMaterial, scene, true);
            this.walls.right.setEnabled(false);
            this.walls.right = newMeshHolePlate;
            let root2 = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["TransformNode"]("");
            this.walls.back.parent = root2;
            this.nuts[6].parent = root2;
            this.nuts[7].parent = root2;
            let wallx = _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["CSG"].FromMesh(this.walls.back);
            let newHolePlatex = wallx.subtract(hole).subtract(hole2).subtract(holex).subtract(holex2);
            let newMeshHolePlatex = newHolePlatex.toMesh("rwn1", concreteMaterial, scene, true);
            this.walls.back.setEnabled(false);
            this.walls.back = newMeshHolePlatex;
            this.nuts[4].setEnabled(false);
            this.nuts[5].setEnabled(false);
            this.nuts[6].setEnabled(false);
            this.nuts[7].setEnabled(false);
            this.resize(floatingSize);
        }
    }
    updateFoamMaterial(type) {
        switch (type || this.floatingSize.type) {
            case 'XPS':
                this.foamMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.9, 0.3, 0.2);
                break;
            default:
                this.foamMaterial.albedoColor = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Color3"](0.2, 0.5, 1.0);
        }
    }
    resize(floatingSize, relativePosition) {
        if (!relativePosition) {
            relativePosition = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0);
        }
        this.walls.top.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, floatingSize.height / 2 - this.outerWallWidth / 2, 0));
        this.walls.top.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length - this.outerWallWidth * 2, floatingSize.width - this.outerWallWidth * 2, 1);
        this.walls.front.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 2 + this.outerWallWidth / 2, 0, -this.outerWallWidth / 2));
        this.walls.front.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.width - this.outerWallWidth, floatingSize.height, 1);
        this.walls.back.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2 - this.outerWallWidth / 2, 0, 0));
        this.walls.back.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.width, floatingSize.height, 1);
        this.walls.left.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, -floatingSize.width / 2 + this.outerWallWidth / 2));
        this.walls.left.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length - this.outerWallWidth * 2, floatingSize.height, 1);
        this.walls.right.position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-this.outerWallWidth / 2, 0, floatingSize.width / 2 - this.outerWallWidth / 2));
        this.walls.right.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length - this.outerWallWidth, floatingSize.height, 1);
        this.foam.scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length - this.outerWallWidth * 2, floatingSize.height - this.outerWallWidth * 2, floatingSize.width - this.outerWallWidth * 2);
        this.foam.position = relativePosition;
        if (this.hooks) {
            let n = 0;
            for (let pos of [[1, 1], [-1, 1], [-1, -1], [1, -1]]) {
                this.hooks[n].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2 * pos[1] * 0.95, floatingSize.height / 2, floatingSize.width / 2 * pos[0] * 0.95));
                n++;
            }
            for (n = 4; n < 8; n++) {
                this.hooks[n].setEnabled(false);
            }
            if (floatingSize.length >= 5.5 /*&& floatingSize.length < 7*/) {
                /*this.hooks[4].position = relativePosition.add(new Vector3(0, floatingSize.height / 2, floatingSize.width / 2 * 0.95));
                this.hooks[4].setEnabled(true);
        
                this.hooks[5].position = relativePosition.add(new Vector3(0, floatingSize.height / 2, - floatingSize.width / 2 * 0.95));
                this.hooks[5].setEnabled(true);
              } else if (floatingSize.length >= 7){*/
                this.hooks[4].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 6, floatingSize.height / 2, floatingSize.width / 2 * 0.95));
                this.hooks[4].setEnabled(true);
                this.hooks[5].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 6 /*floatingSize.length / 2 * 0.5*/, floatingSize.height / 2, -floatingSize.width / 2 * 0.95));
                this.hooks[5].setEnabled(true);
                this.hooks[6].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 6 /*floatingSize.length / 2 * 0.5*/, floatingSize.height / 2, floatingSize.width / 2 * 0.95));
                this.hooks[6].setEnabled(true);
                this.hooks[7].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 6 /*floatingSize.length / 2 * 0.5*/, floatingSize.height / 2, -floatingSize.width / 2 * 0.95));
                this.hooks[7].setEnabled(true);
            }
        }
        if (this.hooksBottom) {
            let n = 0;
            for (let pos of [[1, 1], [-1, 1], [-1, -1], [1, -1]]) {
                this.hooksBottom[n].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2 * pos[1] * 0.95, -floatingSize.height / 2, floatingSize.width / 2 * pos[0] * 0.95));
                n++;
            }
            for (n = 4; n < 8; n++) {
                this.hooksBottom[n].setEnabled(false);
            }
            if (floatingSize.length >= 5.5 /*&& floatingSize.length < 7*/) {
                /*this.hooks[4].position = relativePosition.add(new Vector3(0, floatingSize.height / 2, floatingSize.width / 2 * 0.95));
                this.hooks[4].setEnabled(true);
        
                this.hooks[5].position = relativePosition.add(new Vector3(0, floatingSize.height / 2, - floatingSize.width / 2 * 0.95));
                this.hooks[5].setEnabled(true);
              } else if (floatingSize.length >= 7){*/
                this.hooksBottom[4].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 6, -floatingSize.height / 2, floatingSize.width / 2 * 0.95));
                this.hooksBottom[4].setEnabled(true);
                this.hooksBottom[5].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 6 /*floatingSize.length / 2 * 0.5*/, -floatingSize.height / 2, -floatingSize.width / 2 * 0.95));
                this.hooksBottom[5].setEnabled(true);
                this.hooksBottom[6].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 6 /*floatingSize.length / 2 * 0.5*/, -floatingSize.height / 2, floatingSize.width / 2 * 0.95));
                this.hooksBottom[6].setEnabled(true);
                this.hooksBottom[7].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 6 /*floatingSize.length / 2 * 0.5*/, -floatingSize.height / 2, -floatingSize.width / 2 * 0.95));
                this.hooksBottom[7].setEnabled(true);
            }
        }
        if (this.separatorWalls) {
            for (let i = 0; i < this.separatorWalls.length; i++) {
                this.separatorWalls[i].setEnabled(false);
                this.separatorWalls[i].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.width - 2 * this.outerWallWidth, floatingSize.height, 1);
            }
            if (floatingSize.length >= 5.5 && floatingSize.length < 7) {
                this.separatorWalls[0].setEnabled(true);
                this.separatorWalls[0].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, 0, 0));
            }
            else if (floatingSize.length >= 7) {
                this.separatorWalls[0].setEnabled(true);
                this.separatorWalls[0].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 6, 0, 0));
                this.separatorWalls[1].setEnabled(true);
                this.separatorWalls[1].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 6, 0, 0));
            }
        }
        if (this.rulers) {
            this.rulers[0].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -floatingSize.height / 2, -floatingSize.width / 2 - 0.1));
            this.rulers[1].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2, 0, -floatingSize.width / 2 - 0.1));
            this.rulers[2].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 2, -floatingSize.height / 2, floatingSize.width / 2 - 0.1));
        }
        if (this.nuts) {
            this.nuts[0].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length, floatingSize.height, this.nutSize);
            this.nuts[0].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, floatingSize.height / 6, -floatingSize.width / 2 - this.nutSize / 2));
            this.nuts[1].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length, floatingSize.height, this.nutSize);
            this.nuts[1].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -floatingSize.height / 6, -floatingSize.width / 2 - this.nutSize / 2));
            this.nuts[2].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](this.nutSize, floatingSize.height, floatingSize.width);
            this.nuts[2].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 2 - this.nutSize / 2, floatingSize.height / 6, -this.outerWallWidth / 2));
            this.nuts[3].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](this.nutSize, floatingSize.height, floatingSize.width);
            this.nuts[3].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](-floatingSize.length / 2 - this.nutSize / 2, -floatingSize.height / 6, -this.outerWallWidth / 2));
            this.nuts[4].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length, 1, this.nutSize);
            this.nuts[4].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, floatingSize.height / 6, floatingSize.width / 2 - this.nutSize / 2 + 0.0001));
            this.nuts[5].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length, 1, this.nutSize);
            this.nuts[5].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](0, -floatingSize.height / 6, floatingSize.width / 2 - this.nutSize / 2 + 0.0001));
            this.nuts[6].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](this.nutSize, 1, floatingSize.width);
            this.nuts[6].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2 - this.nutSize / 2 + 0.0001, floatingSize.height / 6, 0));
            this.nuts[7].scaling = new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](this.nutSize, 1, floatingSize.width);
            this.nuts[7].position = relativePosition.add(new _babylonjs_core__WEBPACK_IMPORTED_MODULE_1__["Vector3"](floatingSize.length / 2 - this.nutSize / 2 + 0.0001, -floatingSize.height / 6, 0));
            //this.nuts[1].position = relativePosition.add(new Vector3(- floatingSize.length / 2 - this.nutSize / 2 + 0.001, - floatingSize.height / 6, 0));
            /*let n = 0;
            for (let dir = 0; dir <= 1; dir++){
              let x = 0;
              for (let pos of [ [1,1], [-1,1], [-1,-1], [1,-1] ]){
                if (x <= 1){
                  if (dir){
                    this.nuts[n].position = relativePosition.add(new Vector3(floatingSize.length / 2 * pos[1] - this.nutSize / 2 + 0.001, floatingSize.height / 2 - this.nutSize / 2 + 0.001, floatingSize.width / 2 * pos[0] * 0.6));
                    //this.nuts[n].position = relativePosition.add( new Vector3(floatingSize.width * pos[1] - 0.1 + 0.0001, floatingSize.height - 0.3 + 0.0001, floatingSize.length * pos[0] * 0.6));
                  } else {
                    this.nuts[n].position = relativePosition.add(new Vector3(floatingSize.length / 2 * pos[0] * 0.6, floatingSize.height / 2 - this.nutSize / 2 + 0.001, floatingSize.width / 2 * pos[1] - this.nutSize / 2 + 0.001 ));
                    //this.nuts[n].position = new Vector3(pos[0] * 0.6, 1 - 0.3 + 0.0001, pos[1] - 0.1 + 0.0001);
                  }
                } else {
                  if (dir){
                    this.nuts[n].position = relativePosition.add(new Vector3(floatingSize.length / 2 * pos[1] - this.nutSize / 2 + 0.001, floatingSize.height / 2 - this.nutSize / 2 + 0.001, floatingSize.width / 2 * pos[0] * 0.6));
                    //this.nuts[n].position = new Vector3(pos[1] - 0.1, 1 - 0.3, pos[0] * 0.6);
                  } else {
                    this.nuts[n].position = relativePosition.add(new Vector3(floatingSize.length / 2 * pos[0] * 0.6, floatingSize.height / 2 - this.nutSize / 2 + 0.001, floatingSize.width / 2 * pos[1] - this.nutSize / 2 + 0.001 ));
                    //this.nuts[n].position = new Vector3(pos[0] * 0.6, 1 - 0.3, pos[1] - 0.1);
                  }
                }
                //nut.setParent(this.floatingParentMesh);
                n++;
                x++;
              }
            }*/
        }
    }
}


/***/ }),

/***/ "./src/app/pages/dashboard-page/dashboard-page.component.scss":
/*!********************************************************************!*\
  !*** ./src/app/pages/dashboard-page/dashboard-page.component.scss ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".btn-dashboard {\n  width: 250px;\n}\n\n.btn-primary.disabled {\n  background: #999;\n  border-color: #777;\n}\n\n.planbg {\n  background: url(\"/assets/bg2.png\") no-repeat;\n  background-position: top right;\n  background-size: cover;\n  min-height: calc(100vh - 10rem);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvcGFnZXMvZGFzaGJvYXJkLXBhZ2UvZGFzaGJvYXJkLXBhZ2UuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL2Rhc2hib2FyZC1wYWdlL2Rhc2hib2FyZC1wYWdlLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsWUFBQTtBQ0NGOztBREVBO0VBQ0UsZ0JBQUE7RUFDQSxrQkFBQTtBQ0NGOztBREVBO0VBQ0UsNENBQUE7RUFDQSw4QkFBQTtFQUNBLHNCQUFBO0VBQ0EsK0JBQUE7QUNDRiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2Rhc2hib2FyZC1wYWdlL2Rhc2hib2FyZC1wYWdlLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJ0bi1kYXNoYm9hcmQge1xuICB3aWR0aDogMjUwcHg7XG59XG5cbi5idG4tcHJpbWFyeS5kaXNhYmxlZCB7XG4gIGJhY2tncm91bmQ6ICM5OTk7XG4gIGJvcmRlci1jb2xvcjogIzc3Nztcbn1cblxuLnBsYW5iZyB7XG4gIGJhY2tncm91bmQ6IHVybCgnL2Fzc2V0cy9iZzIucG5nJykgbm8tcmVwZWF0O1xuICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiB0b3AgcmlnaHQ7XG4gIGJhY2tncm91bmQtc2l6ZTogY292ZXI7XG4gIG1pbi1oZWlnaHQ6IGNhbGMoMTAwdmggLSAxMHJlbSk7XG59XG4iLCIuYnRuLWRhc2hib2FyZCB7XG4gIHdpZHRoOiAyNTBweDtcbn1cblxuLmJ0bi1wcmltYXJ5LmRpc2FibGVkIHtcbiAgYmFja2dyb3VuZDogIzk5OTtcbiAgYm9yZGVyLWNvbG9yOiAjNzc3O1xufVxuXG4ucGxhbmJnIHtcbiAgYmFja2dyb3VuZDogdXJsKFwiL2Fzc2V0cy9iZzIucG5nXCIpIG5vLXJlcGVhdDtcbiAgYmFja2dyb3VuZC1wb3NpdGlvbjogdG9wIHJpZ2h0O1xuICBiYWNrZ3JvdW5kLXNpemU6IGNvdmVyO1xuICBtaW4taGVpZ2h0OiBjYWxjKDEwMHZoIC0gMTByZW0pO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/pages/dashboard-page/dashboard-page.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/pages/dashboard-page/dashboard-page.component.ts ***!
  \******************************************************************/
/*! exports provided: DashboardPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardPageComponent", function() { return DashboardPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _services_dialog_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/dialog.service */ "./src/app/services/dialog.service.ts");




let DashboardPageComponent = class DashboardPageComponent {
    constructor(data, dialog) {
        this.data = data;
        this.dialog = dialog;
        this.projects$ = this.data.getProjects();
    }
    ngOnInit() {
    }
    about() {
        this.dialog.about();
    }
};
DashboardPageComponent.ctorParameters = () => [
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _services_dialog_service__WEBPACK_IMPORTED_MODULE_3__["DialogService"] }
];
DashboardPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dashboard-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dashboard-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/dashboard-page/dashboard-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dashboard-page.component.scss */ "./src/app/pages/dashboard-page/dashboard-page.component.scss")).default]
    })
], DashboardPageComponent);



/***/ }),

/***/ "./src/app/pages/design-settings-page/design-settings-page.component.scss":
/*!********************************************************************************!*\
  !*** ./src/app/pages/design-settings-page/design-settings-page.component.scss ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".singleline {\n  white-space: nowrap;\n}\n\nth, td {\n  vertical-align: middle;\n}\n\nth {\n  text-align: center;\n}\n\ninput[type=number] {\n  text-align: right;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvcGFnZXMvZGVzaWduLXNldHRpbmdzLXBhZ2UvZGVzaWduLXNldHRpbmdzLXBhZ2UuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL2Rlc2lnbi1zZXR0aW5ncy1wYWdlL2Rlc2lnbi1zZXR0aW5ncy1wYWdlLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsbUJBQUE7QUNDRjs7QURFQTtFQUNFLHNCQUFBO0FDQ0Y7O0FERUE7RUFDRSxrQkFBQTtBQ0NGOztBREVBO0VBQXVCLGlCQUFBO0FDRXZCIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvZGVzaWduLXNldHRpbmdzLXBhZ2UvZGVzaWduLXNldHRpbmdzLXBhZ2UuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc2luZ2xlbGluZSB7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG5cbnRoLCB0ZCB7XG4gIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG59XG5cbnRoIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG5pbnB1dFt0eXBlPVwibnVtYmVyXCJdIHsgdGV4dC1hbGlnbjogcmlnaHQ7IH1cbiIsIi5zaW5nbGVsaW5lIHtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbn1cblxudGgsIHRkIHtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbn1cblxudGgge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbmlucHV0W3R5cGU9bnVtYmVyXSB7XG4gIHRleHQtYWxpZ246IHJpZ2h0O1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/pages/design-settings-page/design-settings-page.component.ts":
/*!******************************************************************************!*\
  !*** ./src/app/pages/design-settings-page/design-settings-page.component.ts ***!
  \******************************************************************************/
/*! exports provided: DesignSettingsPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DesignSettingsPageComponent", function() { return DesignSettingsPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");




let DesignSettingsPageComponent = class DesignSettingsPageComponent {
    constructor(data, router) {
        this.data = data;
        this.router = router;
        this.wallThicknessTypes = [
            '10 x 7',
            '10 x 8',
            '10 x 9',
            '10 x 10'
        ];
        this.types = [
            'EPS',
            'XPS'
        ];
        this.designSettings$ = data.getDesignSettings();
        this.designSettings$.obj.subscribe(settings => {
            if (!settings.project) {
                // Default settings
                settings.project = {
                    building: {
                        weight: 50,
                        length: 20,
                        width: 10,
                        height: 8,
                        roof: 'Lapos tető',
                        extraWidth: 0
                    },
                    floating: {
                        length: 2.5,
                        useLength2: false,
                        width: 2.5,
                        height: 0.8,
                        aboveWater: 0.2,
                        type: 'EPS',
                        wallThickness: '10 x 7'
                    }
                };
                settings.buildingSettings = {
                    width: { min: 0, max: 50 },
                    length: { min: 0, max: 50 },
                    height: { min: 0, max: 20 },
                    weight: { min: 0, max: 9999999 },
                    extraWidth: { min: 0, max: 20 }
                };
                settings.floatingSettings = {
                    width: { min: 2.5, max: 8 },
                    length: { min: 2.5, max: 8 },
                    height: { min: 0.8, max: 2 },
                    aboveWater: { min: 0.2, max: 1 },
                    wallThickness: { min: '10 x 7', max: '10 x 10' }
                };
                settings.foamSettings = {
                    EPS: { density: 15, price: 200 },
                    XPS: { density: 20, price: 200 }
                };
                settings.solarPower = 260;
                settings.mksz_percent = 10;
                this.save(settings, true);
            }
        });
    }
    ngOnInit() {
    }
    save(settings, noRedirect) {
        this.data.saveDesignSettings(settings);
        if (!noRedirect) {
            this.router.navigate(['/dashboard']);
        }
    }
};
DesignSettingsPageComponent.ctorParameters = () => [
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
DesignSettingsPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-design-settings-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./design-settings-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/design-settings-page/design-settings-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./design-settings-page.component.scss */ "./src/app/pages/design-settings-page/design-settings-page.component.scss")).default]
    })
], DesignSettingsPageComponent);



/***/ }),

/***/ "./src/app/pages/edit-project-page/edit-project-page.component.scss":
/*!**************************************************************************!*\
  !*** ./src/app/pages/edit-project-page/edit-project-page.component.scss ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".steps {\n  position: relative;\n}\n.steps:after {\n  content: \"\";\n  display: block;\n  background: #343a40;\n  width: 100%;\n  height: 4px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  z-index: 1;\n}\n.step {\n  position: relative;\n  z-index: 2;\n  font-weight: bold;\n  font-size: 1.2rem;\n  background: #343a40;\n  margin-left: 1rem;\n  width: 15%;\n}\n.step:first-child {\n  margin-left: 0;\n}\n.step a {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  color: #fff !important;\n  height: 100%;\n}\n.step a > span {\n  display: block;\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n.step a > span span {\n  display: inline-block;\n  font-size: 1rem;\n  width: 2rem;\n  height: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  background: #fff;\n  color: #444;\n  font-weight: bold;\n  border-radius: 50%;\n}\n.step-content {\n  min-height: calc(100vh - 21rem);\n  height: calc(100vh - 21rem);\n  flex-wrap: wrap;\n}\n.unclickable {\n  cursor: default;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/pages/edit-project-page/edit-project-page.component.ts":
/*!************************************************************************!*\
  !*** ./src/app/pages/edit-project-page/edit-project-page.component.ts ***!
  \************************************************************************/
/*! exports provided: EditProjectPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditProjectPageComponent", function() { return EditProjectPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _services_dialog_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/dialog.service */ "./src/app/services/dialog.service.ts");
/* harmony import */ var _dialogs_project_name_dialog_project_name_dialog_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../dialogs/project-name-dialog/project-name-dialog.component */ "./src/app/dialogs/project-name-dialog/project-name-dialog.component.ts");






//declare const jQuery:any;
let EditProjectPageComponent = class EditProjectPageComponent {
    constructor(route, router, data, dialog) {
        this.route = route;
        this.router = router;
        this.data = data;
        this.dialog = dialog;
        this.step = 1;
        this.steps = [
            { id: 1, name: 'Felépítmény' },
            { id: 2, name: 'Úszómű elem' },
            { id: 3, name: 'Úszómű elem + Felépítmény' },
            { id: 4, name: 'Eredmény' }
        ];
    }
    ngOnInit() {
        this.route.params.subscribe(routeParams => {
            switch (routeParams.projectEditMode) {
                case 'copy':
                    this.createByCopy(routeParams.id);
                    break;
                case 'modify':
                    this.createByModifying(routeParams.id);
                    break;
                case 'create':
                    this.createNew();
                    break;
            }
        });
    }
    createByCopy(projectId) {
        this.pageTitle = 'Új Ponton Terv másolatból';
        this.data.getProject(projectId).obj.subscribe(project => {
            this.project = project;
            this.askProjectName();
            delete (this.project.key);
            delete (this.project.version);
        });
    }
    createByModifying(projectId) {
        this.pageTitle = 'Ponton Terv módosítása';
        this.data.getProject(projectId).obj.subscribe(project => {
            this.project = project;
            delete (this.project.key);
        });
    }
    createNew() {
        this.pageTitle = 'Új Ponton Terv készítés';
        this.data.getDefaultProjectSettings().subscribe((defaultProjectSettings) => {
            this.project = Object.assign({}, defaultProjectSettings);
            this.askProjectName();
        });
    }
    askProjectName() {
        this.dialog.showDialog(_dialogs_project_name_dialog_project_name_dialog_component__WEBPACK_IMPORTED_MODULE_5__["ProjectNameDialogComponent"], {}).then((projectName) => {
            this.project.name = projectName;
            if (!projectName) {
                this.router.navigate(['/dashboard']);
            }
        }).catch(() => {
            this.router.navigate(['/dashboard']);
        });
    }
    prev() {
        if (this.step > 1) {
            this.step--;
        }
    }
    next() {
        if (this.step < this.steps.length) {
            this.step++;
        }
    }
    print() {
        this.results.print();
    }
    save() {
        this.data.saveProject(this.project).then(() => {
            this.router.navigate(['/dashboard']);
        });
    }
};
EditProjectPageComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _services_dialog_service__WEBPACK_IMPORTED_MODULE_4__["DialogService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('results', { static: false })
], EditProjectPageComponent.prototype, "results", void 0);
EditProjectPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-edit-project-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./edit-project-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/edit-project-page/edit-project-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./edit-project-page.component.scss */ "./src/app/pages/edit-project-page/edit-project-page.component.scss")).default]
    })
], EditProjectPageComponent);



/***/ }),

/***/ "./src/app/pages/help-page/help-page.component.scss":
/*!**********************************************************!*\
  !*** ./src/app/pages/help-page/help-page.component.scss ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2hlbHAtcGFnZS9oZWxwLXBhZ2UuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/help-page/help-page.component.ts":
/*!********************************************************!*\
  !*** ./src/app/pages/help-page/help-page.component.ts ***!
  \********************************************************/
/*! exports provided: HelpPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelpPageComponent", function() { return HelpPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HelpPageComponent = class HelpPageComponent {
    constructor() { }
    ngOnInit() {
    }
};
HelpPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-help-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./help-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/help-page/help-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./help-page.component.scss */ "./src/app/pages/help-page/help-page.component.scss")).default]
    })
], HelpPageComponent);



/***/ }),

/***/ "./src/app/pages/login-page/login-page.component.scss":
/*!************************************************************!*\
  !*** ./src/app/pages/login-page/login-page.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".card {\n  width: 400px;\n  max-width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvcGFnZXMvbG9naW4tcGFnZS9sb2dpbi1wYWdlLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9wYWdlcy9sb2dpbi1wYWdlL2xvZ2luLXBhZ2UuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxZQUFBO0VBQ0EsZUFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvbG9naW4tcGFnZS9sb2dpbi1wYWdlLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNhcmQge1xuICAgIHdpZHRoOiA0MDBweDtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG59XG4iLCIuY2FyZCB7XG4gIHdpZHRoOiA0MDBweDtcbiAgbWF4LXdpZHRoOiAxMDAlO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/pages/login-page/login-page.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/pages/login-page/login-page.component.ts ***!
  \**********************************************************/
/*! exports provided: LoginPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginPageComponent", function() { return LoginPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! firebase/app */ "./node_modules/firebase/app/dist/index.cjs.js");
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(firebase_app__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");






let LoginPageComponent = class LoginPageComponent {
    constructor(afAuth, router, dataService) {
        this.afAuth = afAuth;
        this.router = router;
        this.dataService = dataService;
        this.user = {};
    }
    ngOnInit() {
    }
    handleLogin(loginPromise, addUserInfo) {
        loginPromise.then((u) => {
            if (addUserInfo) {
                this.dataService.addUserInfo(u.user.uid, {
                    name: u.user.displayName,
                    email: u.user.email,
                    enabled: true
                });
            }
            this.router.navigate(['/dashboard']);
        }).catch(() => {
            this.loginError = true;
        });
    }
    login() {
        this.loginError = false;
        this.handleLogin(this.afAuth.auth.signInWithEmailAndPassword(this.user.email, this.user.password));
    }
    loginWithGoogle() {
        this.loginError = false;
        this.handleLogin(this.afAuth.auth.signInWithPopup(new firebase_app__WEBPACK_IMPORTED_MODULE_4__["auth"].GoogleAuthProvider()), true);
    }
};
LoginPageComponent.ctorParameters = () => [
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__["AngularFireAuth"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_5__["DataService"] }
];
LoginPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login-page/login-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login-page.component.scss */ "./src/app/pages/login-page/login-page.component.scss")).default]
    })
], LoginPageComponent);



/***/ }),

/***/ "./src/app/pages/projects-page/projects-page.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/pages/projects-page/projects-page.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("th, td {\n  vertical-align: middle !important;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvcGFnZXMvcHJvamVjdHMtcGFnZS9wcm9qZWN0cy1wYWdlLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9wYWdlcy9wcm9qZWN0cy1wYWdlL3Byb2plY3RzLXBhZ2UuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxpQ0FBQTtBQ0NGIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvcHJvamVjdHMtcGFnZS9wcm9qZWN0cy1wYWdlLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsidGgsIHRkIHtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZSAhaW1wb3J0YW50O1xuXG59XG4iLCJ0aCwgdGQge1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlICFpbXBvcnRhbnQ7XG59Il19 */");

/***/ }),

/***/ "./src/app/pages/projects-page/projects-page.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/pages/projects-page/projects-page.component.ts ***!
  \****************************************************************/
/*! exports provided: ProjectsPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectsPageComponent", function() { return ProjectsPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _services_dialog_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/dialog.service */ "./src/app/services/dialog.service.ts");





let ProjectsPageComponent = class ProjectsPageComponent {
    constructor(route, router, data, dialog) {
        this.route = route;
        this.router = router;
        this.data = data;
        this.dialog = dialog;
    }
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.action = params.action;
            switch (this.action) {
                case 'copy':
                    this.pageTitle = 'Új Ponton Terv másolatból';
                    break;
                case 'modify':
                    this.pageTitle = 'Ponton Terv módosítása';
                    break;
            }
            this.projects$ = this.data.getProjects();
        });
    }
    delete(project) {
        this.dialog.confirm("Biztosan törölni szeretné a projekt terv verziót?").then(() => {
            this.data.deleteProject(project);
        });
    }
};
ProjectsPageComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _services_dialog_service__WEBPACK_IMPORTED_MODULE_4__["DialogService"] }
];
ProjectsPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-projects-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./projects-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/projects-page/projects-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./projects-page.component.scss */ "./src/app/pages/projects-page/projects-page.component.scss")).default]
    })
], ProjectsPageComponent);



/***/ }),

/***/ "./src/app/pages/signup-page/signup-page.component.scss":
/*!**************************************************************!*\
  !*** ./src/app/pages/signup-page/signup-page.component.scss ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".card {\n  width: 400px;\n  max-width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvcGFnZXMvc2lnbnVwLXBhZ2Uvc2lnbnVwLXBhZ2UuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL3NpZ251cC1wYWdlL3NpZ251cC1wYWdlLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksWUFBQTtFQUNBLGVBQUE7QUNDSiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3NpZ251cC1wYWdlL3NpZ251cC1wYWdlLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNhcmQge1xuICAgIHdpZHRoOiA0MDBweDtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG59XG4iLCIuY2FyZCB7XG4gIHdpZHRoOiA0MDBweDtcbiAgbWF4LXdpZHRoOiAxMDAlO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/pages/signup-page/signup-page.component.ts":
/*!************************************************************!*\
  !*** ./src/app/pages/signup-page/signup-page.component.ts ***!
  \************************************************************/
/*! exports provided: SignupPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignupPageComponent", function() { return SignupPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");





let SignupPageComponent = class SignupPageComponent {
    constructor(afAuth, router, dataService) {
        this.afAuth = afAuth;
        this.router = router;
        this.dataService = dataService;
        this.user = {};
    }
    ngOnInit() {
    }
    handleSignup(signupPromise) {
        signupPromise.then(() => {
            this.afAuth.auth.signInWithEmailAndPassword(this.user.email, this.user.password).then((u) => {
                this.dataService.addUserInfo(u.user.uid, {
                    name: this.user.name,
                    email: this.user.email,
                    enabled: true
                });
                this.router.navigate(['/dashboard']);
            });
        }).catch(() => {
            this.signupError = true;
        });
    }
    signup() {
        this.signupError = false;
        this.handleSignup(this.afAuth.auth.createUserWithEmailAndPassword(this.user.email, this.user.password));
    }
};
SignupPageComponent.ctorParameters = () => [
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_2__["AngularFireAuth"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] }
];
SignupPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-signup-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./signup-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/signup-page/signup-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./signup-page.component.scss */ "./src/app/pages/signup-page/signup-page.component.scss")).default]
    })
], SignupPageComponent);



/***/ }),

/***/ "./src/app/pages/tech-settings-page/tech-settings-page.component.scss":
/*!****************************************************************************!*\
  !*** ./src/app/pages/tech-settings-page/tech-settings-page.component.scss ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3RlY2gtc2V0dGluZ3MtcGFnZS90ZWNoLXNldHRpbmdzLXBhZ2UuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/tech-settings-page/tech-settings-page.component.ts":
/*!**************************************************************************!*\
  !*** ./src/app/pages/tech-settings-page/tech-settings-page.component.ts ***!
  \**************************************************************************/
/*! exports provided: TechSettingsPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TechSettingsPageComponent", function() { return TechSettingsPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let TechSettingsPageComponent = class TechSettingsPageComponent {
    constructor() {
        this.settings = {
            inactivity: 30,
            logExpiration: 180,
            archiveDays: 7,
            archiveHost: 'archive.ponton-terv.web.app'
        };
    }
    ngOnInit() {
    }
    save() { }
};
TechSettingsPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-tech-settings-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tech-settings-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/tech-settings-page/tech-settings-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tech-settings-page.component.scss */ "./src/app/pages/tech-settings-page/tech-settings-page.component.scss")).default]
    })
], TechSettingsPageComponent);



/***/ }),

/***/ "./src/app/pages/users-page/users-page.component.scss":
/*!************************************************************!*\
  !*** ./src/app/pages/users-page/users-page.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("th, td {\n  vertical-align: middle !important;\n}\nth .form-control, td .form-control {\n  background: rgba(100, 100, 100, 0.1);\n  border: 0 none;\n  box-shadow: none;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RpYmkvcHJvamVjdHMvZXViL3BvbnRvbi10ZXJ2L3NyYy9hcHAvcGFnZXMvdXNlcnMtcGFnZS91c2Vycy1wYWdlLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9wYWdlcy91c2Vycy1wYWdlL3VzZXJzLXBhZ2UuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxpQ0FBQTtBQ0NGO0FEQ0U7RUFDRSxvQ0FBQTtFQUNBLGNBQUE7RUFDQSxnQkFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvdXNlcnMtcGFnZS91c2Vycy1wYWdlLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsidGgsIHRkIHtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZSAhaW1wb3J0YW50O1xuXG4gIC5mb3JtLWNvbnRyb2wge1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMTAwLDEwMCwxMDAsMC4xKTtcbiAgICBib3JkZXI6IDAgbm9uZTtcbiAgICBib3gtc2hhZG93OiBub25lO1xuICB9XG59XG4iLCJ0aCwgdGQge1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlICFpbXBvcnRhbnQ7XG59XG50aCAuZm9ybS1jb250cm9sLCB0ZCAuZm9ybS1jb250cm9sIHtcbiAgYmFja2dyb3VuZDogcmdiYSgxMDAsIDEwMCwgMTAwLCAwLjEpO1xuICBib3JkZXI6IDAgbm9uZTtcbiAgYm94LXNoYWRvdzogbm9uZTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/pages/users-page/users-page.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/pages/users-page/users-page.component.ts ***!
  \**********************************************************/
/*! exports provided: UsersPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UsersPageComponent", function() { return UsersPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _services_dialog_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/dialog.service */ "./src/app/services/dialog.service.ts");




let UsersPageComponent = class UsersPageComponent {
    constructor(data, dialog) {
        this.data = data;
        this.dialog = dialog;
        this.roles = [
            { id: undefined, name: 'Tervező' },
            { id: 'admin', name: 'Admin' }
        ];
        this.changed = {};
        this.users$ = data.getUsers();
    }
    ngOnInit() {
    }
    save(user) {
        this.data.saveUser(user).then(() => {
            this.changed[user.key] = false;
        });
    }
    delete(user) {
        this.dialog.confirm("Biztosan törölni szeretné a felhasználót?").then(() => {
            user.deleted = true;
            this.data.saveUser(user).then(() => { });
        });
    }
};
UsersPageComponent.ctorParameters = () => [
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _services_dialog_service__WEBPACK_IMPORTED_MODULE_3__["DialogService"] }
];
UsersPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-users-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./users-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/users-page/users-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./users-page.component.scss */ "./src/app/pages/users-page/users-page.component.scss")).default]
    })
], UsersPageComponent);



/***/ }),

/***/ "./src/app/services/data.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/data.service.ts ***!
  \******************************************/
/*! exports provided: DataService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataService", function() { return DataService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_database__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/database */ "./node_modules/@angular/fire/database/es2015/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let DataService = class DataService {
    constructor(db, auth) {
        this.db = db;
        this.auth = auth;
        this.auth.user.subscribe((user) => {
            this.user = user;
            if (user) {
                this.db.object('/users/' + user.uid).snapshotChanges().subscribe(userInfo => {
                    this.userInfo = userInfo.payload.val();
                    if (!this.userInfo.enabled) {
                        this.auth.auth.signOut();
                    }
                });
            }
            else {
                this.userInfo = null;
            }
        });
    }
    get isAdmin() {
        return this.userInfo && this.userInfo.role === 'admin';
    }
    addKeyToList(ref) {
        return ref.snapshotChanges().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])((changes) => changes.map(c => (Object.assign({ key: c.payload.key }, c.payload.val())))));
    }
    getList(path, params) {
        let ref = this.db.list(path, params);
        let list = this.addKeyToList(ref);
        return { ref, list };
    }
    getObject(path) {
        let ref = this.db.object(path);
        let obj = ref.snapshotChanges().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(c => (Object.assign({ key: c.payload.key }, c.payload.val()))));
        return { ref, obj };
    }
    addUserInfo(uid, userInfo) {
        userInfo.createdAt = Date.now();
        this.db.object('/users/' + uid).update(userInfo);
    }
    getUsers() {
        return this.getList('/users');
    }
    saveUser(user) {
        let userUpdate = {
            name: user.name,
            email: user.email,
            enabled: user.enabled,
        };
        if (user.role) {
            userUpdate.role = user.role;
        }
        else {
            this.db.object('/users/' + user.key + '/role').remove();
        }
        if (user.deleted) {
            userUpdate.deleted = true;
        }
        return this.db.object('/users/' + user.key).update(userUpdate);
    }
    getProjects() {
        return this.getList('/projects');
    }
    getProject(id) {
        return this.getObject('/projects/' + id);
    }
    deleteProject(project) {
        return this.db.object('/projects/' + project.key).remove();
    }
    saveProject(project) {
        if (!project.version) {
            project.version = 1;
        }
        else {
            project.version++;
        }
        project.createdAt = Date.now();
        project.designer = this.userInfo;
        if (!project.key) {
            delete (project.key);
        }
        return this.db.list('/projects').push(project);
    }
    getDesignSettings() {
        return this.getObject('/settings');
    }
    saveDesignSettings(settings) {
        this.db.object('/settings').set(settings);
    }
    getDefaultProjectSettings() {
        return this.getObject('/settings/project').obj.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(obj => (Object.assign({}, obj, { key: undefined }))));
    }
};
DataService.ctorParameters = () => [
    { type: _angular_fire_database__WEBPACK_IMPORTED_MODULE_2__["AngularFireDatabase"] },
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"] }
];
DataService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], DataService);



/***/ }),

/***/ "./src/app/services/dialog.service.ts":
/*!********************************************!*\
  !*** ./src/app/services/dialog.service.ts ***!
  \********************************************/
/*! exports provided: DialogService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogService", function() { return DialogService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _dialogs_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../dialogs/confirm-dialog/confirm-dialog.component */ "./src/app/dialogs/confirm-dialog/confirm-dialog.component.ts");
/* harmony import */ var _dialogs_about_dialog_about_dialog_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../dialogs/about-dialog/about-dialog.component */ "./src/app/dialogs/about-dialog/about-dialog.component.ts");





let DialogService = class DialogService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    showDialog(component, params, options) {
        options = Object.assign({ size: 'lg' }, options);
        const dialog = this.modalService.open(component, options);
        if (params) {
            for (let key in params) {
                dialog.componentInstance[key] = params[key];
            }
        }
        return dialog.result;
    }
    confirm(message, params) {
        return this.showDialog(_dialogs_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_3__["ConfirmDialogComponent"], { message, params });
    }
    about() {
        return this.showDialog(_dialogs_about_dialog_about_dialog_component__WEBPACK_IMPORTED_MODULE_4__["AboutDialogComponent"], {});
    }
};
DialogService.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbModal"] }
];
DialogService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], DialogService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const environment = {
    production: false,
    version: '1.3.1',
    firebase: {
        apiKey: "AIzaSyAudbj1bhh_YkUy0fvVVoB577zRTmGZPNw",
        authDomain: "pontonterv.firebaseapp.com",
        databaseURL: "https://pontonterv.firebaseio.com",
        projectId: "pontonterv",
        storageBucket: "pontonterv.appspot.com",
        messagingSenderId: "568375194575",
        appId: "1:568375194575:web:87c66ef0907c3430f7d8ba"
    }
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/tibi/projects/eub/ponton-terv/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map